/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./js/components/autoplay-text-wrapper.js"
/*!************************************************!*\
  !*** ./js/components/autoplay-text-wrapper.js ***!
  \************************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ initAutoplayTextWrapper)
/* harmony export */ });
/**
 * Autoplay Text Wrapper Component
 * Handles auto-rotation of autoplay-text items with animated border progress indicator
 */

class AutoplayTextWrapper {
  constructor(wrapper) {
    this.items = wrapper.querySelectorAll('.autoplay-text-wrapper__item');
    this.progressBorders = wrapper.querySelectorAll('.autoplay-text-wrapper__border-progress');
    this.delay = parseInt(wrapper.getAttribute('data-autoplay-delay')) || 3000;
    this.progressColor = wrapper.getAttribute('data-progress-color');
    this.progressBgColor = wrapper.getAttribute('data-progress-bg-color');
    this.currentIndex = 0;
    this.progressRaf = null;
    this.autoplayInterval = null;
    this.progressTimeout = null;
    this.isTransitioning = false;
    this.isInitialized = false;
    if (this.items.length <= 1) return;
    this.init();
  }
  init() {
    this.items.forEach((item, index) => {
      var headingElement = item.querySelector('.subheading__subheading-medium');
      if (headingElement) {
        headingElement.setAttribute('data-original-color', window.getComputedStyle(headingElement).color);
      }

      // Add click handler to make items clickable
      item.addEventListener('click', () => {
        this.handleItemClick(index);
      });
    });
    this.setActiveItem(0, true); // true indicates initial load
    this.isInitialized = true;
    this.startAutoplay();
  }
  handleItemClick(index) {
    // Prevent rapid clicks during transition
    if (this.isTransitioning) return;

    // Clear existing intervals and timeouts to reset progress
    this.clearAllTimers();

    // Set the clicked item as active and reset progress
    this.setActiveItem(index, false);

    // Restart autoplay
    this.startAutoplay();
  }
  setActiveItem(index) {
    var isInitialLoad = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var previousIndex = this.currentIndex;
    var isTransitioningOut = previousIndex !== index && previousIndex !== -1;

    // Clear any pending timeout
    if (this.progressTimeout) {
      clearTimeout(this.progressTimeout);
      this.progressTimeout = null;
    }

    // Set transitioning flag
    if (isTransitioningOut) {
      this.isTransitioning = true;
    }

    // First, handle the transition out (collapse subheading)
    if (isTransitioningOut) {
      var previousItem = this.items[previousIndex];

      // Remove active class to trigger collapse animation
      previousItem === null || previousItem === void 0 || previousItem.classList.remove('autoplay-text-wrapper__item--active');

      // Reset heading color
      var previousHeading = previousItem === null || previousItem === void 0 ? void 0 : previousItem.querySelector('.subheading__subheading-medium');
      if (previousHeading) {
        previousHeading.style.color = previousHeading.getAttribute('data-original-color') || '';
      }
    }

    // Then handle the new active item
    this.items.forEach((item, i) => {
      var headingElement = item.querySelector('.subheading__subheading-medium');
      var isActive = i === index;
      if (isActive) {
        item.classList.add('autoplay-text-wrapper__item--active');
        if (headingElement) {
          headingElement.style.color = this.progressColor;
        }
      } else if (i !== previousIndex) {
        // Ensure other items are not active
        item.classList.remove('autoplay-text-wrapper__item--active');
        if (headingElement) {
          headingElement.style.color = headingElement.getAttribute('data-original-color') || '';
        }
      }
    });

    // Handle progress bar animation with proper sequencing
    this.progressBorders.forEach((border, i) => {
      var borderBase = border.previousElementSibling;
      if (i === index) {
        // Only reset progress bar if not initial load or if it's not already at 100%
        var currentWidth = parseFloat(border.style.width) || 0;
        if (!isInitialLoad || currentWidth < 100) {
          border.style.width = '0%';
        }
        border.style.backgroundColor = this.progressColor;
        if (borderBase) {
          borderBase.style.backgroundColor = this.progressBgColor;
        }

        // If transitioning from another item, wait for subheading to collapse (1000ms)
        // Then start progress bar animation
        if (isTransitioningOut) {
          this.progressTimeout = setTimeout(() => {
            this.isTransitioning = false;
            // Calculate remaining time: delay - 1000ms (wait time)
            var remainingDelay = Math.max(this.delay - 1000, 500);
            this.animateProgress(border, remainingDelay);
          }, 1000);
        } else {
          // First load or direct click - start immediately
          if (isInitialLoad && currentWidth >= 100) {
            // Don't animate if already at 100% on initial load
            return;
          }
          this.animateProgress(border, this.delay);
        }
      } else {
        border.style.width = '0%';
        border.style.backgroundColor = this.progressBgColor;
        if (borderBase) {
          borderBase.style.backgroundColor = this.progressBgColor;
        }
      }
    });
    this.currentIndex = index;
  }
  animateProgress(border, duration) {
    if (this.progressRaf) {
      cancelAnimationFrame(this.progressRaf);
      this.progressRaf = null;
    }
    var startWidth = parseFloat(border.style.width) || 0;
    var startTime = performance.now();
    var tick = now => {
      var elapsed = now - startTime;
      var progress = Math.min(elapsed / duration, 1);
      var width = startWidth + (100 - startWidth) * progress;
      border.style.width = "".concat(width, "%");
      if (progress < 1) {
        this.progressRaf = requestAnimationFrame(tick);
      } else {
        this.progressRaf = null;
      }
    };
    this.progressRaf = requestAnimationFrame(tick);
  }
  startAutoplay() {
    if (this.autoplayInterval) clearInterval(this.autoplayInterval);
    this.autoplayInterval = setInterval(() => this.nextItem(), this.delay);
  }
  nextItem() {
    // Don't transition if already transitioning
    if (this.isTransitioning) return;
    this.setActiveItem((this.currentIndex + 1) % this.items.length);
  }
  clearAllTimers() {
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
      this.autoplayInterval = null;
    }
    if (this.progressTimeout) {
      clearTimeout(this.progressTimeout);
      this.progressTimeout = null;
    }
    if (this.progressRaf) {
      cancelAnimationFrame(this.progressRaf);
      this.progressRaf = null;
    }
  }
  destroy() {
    this.clearAllTimers();
    this.isTransitioning = false;
  }
}
function initAutoplayTextWrapper() {
  document.querySelectorAll('.autoplay-text-wrapper').forEach(wrapper => {
    if (!wrapper.dataset.initialized) {
      new AutoplayTextWrapper(wrapper);
      wrapper.dataset.initialized = 'true';
    }
  });
}
document.addEventListener('DOMContentLoaded', initAutoplayTextWrapper);
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', event => {
    var wrapper = event.target.querySelector('.autoplay-text-wrapper');
    if (wrapper) {
      wrapper.dataset.initialized = 'false';
      initAutoplayTextWrapper();
    }
  });
}

/***/ },

/***/ "./js/components/financial-data.js"
/*!*****************************************!*\
  !*** ./js/components/financial-data.js ***!
  \*****************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   initFinancialData: () => (/* binding */ initFinancialData)
/* harmony export */ });
/* harmony import */ var _skeleton__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../skeleton */ "./js/skeleton.js");
/**
 * Financial Statements via B2I FundamentalData.asp.
 * Fetch HTML and inject into div (unique ids: Fin1Div, Fin2Div, …).
 * Params: b, api, dv, m, t, c, s, refid. m: 1=Cash Flow, 2=Income, 3=Balance Sheet.
 */

var B2I_CONFIG = {
  bizID: '2426',
  apiKey: 'Y4N6i3H3G8'
};
var B2I_BASE = 'https://www.b2i.us/b2i/FundamentalData.asp';
var FIN_STATEMENT_MODE = {
  cashflow: 1,
  income: 2,
  balance: 3
};
var DEFAULT_PERIOD_TYPE = 1;
var DEFAULT_COUNT = 8;
var nextDivIndex = 0;
var buildFundamentalDataUrl = _ref => {
  var divId = _ref.divId,
    symbol = _ref.symbol,
    mode = _ref.mode,
    refId = _ref.refId,
    _ref$t = _ref.t,
    t = _ref$t === void 0 ? DEFAULT_PERIOD_TYPE : _ref$t,
    _ref$c = _ref.c,
    c = _ref$c === void 0 ? DEFAULT_COUNT : _ref$c;
  var params = new URLSearchParams({
    b: B2I_CONFIG.bizID,
    api: B2I_CONFIG.apiKey,
    dv: divId,
    m: String(mode),
    t: String(t),
    c: String(c),
    s: symbol || ''
  });
  if (refId) params.set('refid', refId);
  return "".concat(B2I_BASE, "?").concat(params.toString());
};
var B2I_ORIGIN = 'https://www.b2i.us';

/** Extract styles from head and safe body HTML; inject both so API styles apply. */
var injectHtmlWithStyles = function injectHtmlWithStyles(container, html) {
  var _doc$head;
  var baseUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : B2I_BASE;
  var doc = new DOMParser().parseFromString(html, 'text/html');
  doc.querySelectorAll('script').forEach(el => el.remove());
  var base = new URL(baseUrl);
  var fragment = document.createDocumentFragment();
  var headStyles = ((_doc$head = doc.head) === null || _doc$head === void 0 ? void 0 : _doc$head.querySelectorAll('style, link[rel="stylesheet"]')) || [];
  headStyles.forEach(el => {
    var clone = el.cloneNode(true);
    if (clone.tagName === 'LINK' && clone.href) {
      try {
        clone.href = new URL(clone.getAttribute('href') || '', base).href;
      } catch (_) {}
    }
    fragment.appendChild(clone);
  });

  /* Append body's children directly so all blocks (e.g. Income + Comprehensive Income) are preserved */
  var bodyWrap = document.createElement('div');
  bodyWrap.className = 'b2i-fin-api-content';
  if (doc.body) {
    while (doc.body.firstChild) {
      bodyWrap.appendChild(doc.body.firstChild);
    }
  }
  fragment.appendChild(bodyWrap);
  container.innerHTML = '';
  container.appendChild(fragment);
};
var loadFinancials = (divId, symbol, mode, refId) => {
  var container = document.getElementById(divId);
  if (!container) return;
  (0,_skeleton__WEBPACK_IMPORTED_MODULE_0__.initSkeleton)(container, {
    rows: 8,
    cols: 4
  });
  var url = buildFundamentalDataUrl({
    divId,
    symbol,
    mode,
    refId
  });
  var injectIframe = () => {
    container.innerHTML = '';
    var iframe = document.createElement('iframe');
    iframe.setAttribute('src', url);
    iframe.setAttribute('title', 'Financial statements');
    iframe.style.width = '100%';
    iframe.style.minHeight = '400px';
    iframe.style.border = 'none';
    container.appendChild(iframe);
  };
  fetch(url, {
    mode: 'cors'
  }).then(res => {
    if (!res.ok) throw new Error("HTTP ".concat(res.status));
    return res.text();
  }).then(html => {
    if (!html || !html.trim()) throw new Error('Empty response');
    injectHtmlWithStyles(container, html);
    container.dispatchEvent(new CustomEvent('table-scrollbar-refresh'));
  }).catch(() => {
    injectIframe();
    container.dispatchEvent(new CustomEvent('table-scrollbar-refresh'));
  });
};
var initFinancialsInstance = root => {
  var _root$dataset$finSymb;
  var symbol = (_root$dataset$finSymb = root.dataset.finSymbol) === null || _root$dataset$finSymb === void 0 ? void 0 : _root$dataset$finSymb.trim();
  var content = root.querySelector('[data-fin-content]');
  var yearSelector = root.querySelector('[data-fin-year-selector]');
  var statementSelector = root.querySelector('[data-fin-statement-select]');
  if (!symbol || !content) return;
  var divId = "Fin".concat(++nextDivIndex, "Div");
  content.id = divId;
  var load = () => {
    var _FIN_STATEMENT_MODE$t;
    var refId = (yearSelector === null || yearSelector === void 0 ? void 0 : yearSelector.value) || null;
    var type = (statementSelector === null || statementSelector === void 0 ? void 0 : statementSelector.value) || 'balance';
    var mode = (_FIN_STATEMENT_MODE$t = FIN_STATEMENT_MODE[type]) !== null && _FIN_STATEMENT_MODE$t !== void 0 ? _FIN_STATEMENT_MODE$t : FIN_STATEMENT_MODE.balance;
    loadFinancials(divId, symbol, mode, refId);
  };
  yearSelector === null || yearSelector === void 0 || yearSelector.addEventListener('change', load);
  statementSelector === null || statementSelector === void 0 || statementSelector.addEventListener('change', load);
  load();
};
var initFinancialData = () => {
  nextDivIndex = 0;
  document.querySelectorAll('[data-fin-symbol]').forEach(initFinancialsInstance);
};

/***/ },

/***/ "./js/components/financial-table.js"
/*!******************************************!*\
  !*** ./js/components/financial-table.js ***!
  \******************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
var financialTable = () => {
  var showYear = (wrapper, year) => {
    wrapper.querySelectorAll('.year-data-block').forEach(block => {
      block.classList.toggle('active', block.getAttribute('data-year') === year);
    });
  };
  var init = () => {
    document.querySelectorAll('[class*="financial-table-wrapper-"]').forEach(wrapper => {
      var select = wrapper.querySelector('[data-year-selector]');
      if (select) showYear(wrapper, select.value);
    });
  };
  document.addEventListener('change', e => {
    if (!e.target.matches('[data-year-selector]')) return;
    var wrapper = e.target.closest('[class*="financial-table-wrapper-"]');
    if (wrapper) showYear(wrapper, e.target.value);
  });
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('migrationComplete', init);
  document.addEventListener('shopify:section:load', init);
  if (document.readyState !== 'loading') init();
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (financialTable);

/***/ },

/***/ "./js/components/header-search.js"
/*!****************************************!*\
  !*** ./js/components/header-search.js ***!
  \****************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   debounce: () => (/* binding */ debounce),
/* harmony export */   getHeaderSearch: () => (/* binding */ getHeaderSearch)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js");

var searchUrl = window.Shopify.routes.root + "search?sections=header-search";
var debounce = (func, delay) => {
  var timeout;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
};
var getHeaderSearch = /*#__PURE__*/function () {
  var _ref = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* (query) {
    try {
      var params = new URLSearchParams({
        q: query
      });
      var response = yield fetch("".concat(searchUrl, "&").concat(params));
      if (!response.ok) throw new Error(response.statusText);
      return response.json();
    } catch (e) {
      console.error(e);
      return [];
    }
  });
  return function getHeaderSearch(_x) {
    return _ref.apply(this, arguments);
  };
}();

/***/ },

/***/ "./js/components/header.js"
/*!*********************************!*\
  !*** ./js/components/header.js ***!
  \*********************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js");
/* harmony import */ var JsComponents_header_search_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! JsComponents/header-search.js */ "./js/components/header-search.js");


/**
 * Move megamenu section content into header placeholders and
 * attach hover/focus interactions for desktop navigation.
 *
 * - Megamenu sections: `.megamenu-section[data-megamenu-id]`
 * - Desktop placeholders: `.site-header__megamenu-placeholder[data-megamenu-id]`
 * - Mobile placeholders: `.site-header__mobile-megamenu-placeholder[data-megamenu-id]`
 */
function initHeaderMegamenu() {
  var root = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  var header = root.querySelector('[data-header]') || document.querySelector('[data-header]');
  if (!header) return;
  if (header.dataset.megamenuInitialized === 'true') return;
  header.dataset.megamenuInitialized = 'true';

  // ================================
  // Move megamenu section content
  // ================================
  var sections = root.querySelectorAll('[data-megamenu-section]');
  sections.forEach(section => {
    var id = section.dataset.megamenuId;
    if (!id || section.dataset.megamenuMounted === 'true') return;
    var fragment = document.createDocumentFragment();
    while (section.firstChild) {
      fragment.appendChild(section.firstChild);
    }
    if (section.dataset.megamenuDesktopContent == "true") {
      var desktopTarget = root.querySelector("[data-megamenu-desktop][data-megamenu-id=\"".concat(id, "\"]"));
      if (desktopTarget) {
        desktopTarget.innerHTML = '';
        desktopTarget.appendChild(fragment.cloneNode(true));
      }
    }
    if (section.dataset.megamenuMobileContent == "true") {
      var mobileTarget = root.querySelector("[data-megamenu-mobile][data-megamenu-id=\"".concat(id, "\"]"));
      if (mobileTarget) {
        mobileTarget.innerHTML = '';
        mobileTarget.appendChild(fragment.cloneNode(true));
      }
    }
    section.style.display = 'none';
    section.dataset.megamenuMounted = 'true';
  });

  // ================================
  // Desktop hover / focus interactivity
  // ================================
  var triggers = header.querySelectorAll('[data-megamenu-trigger]');
  var panels = header.querySelectorAll('[data-megamenu-desktop][data-megamenu-id]');
  var activePanel = null;
  var hideAllPanels = () => {
    panels.forEach(panel => panel.classList.add('tw-hidden'));
    triggers.forEach(trigger => {
      var linkEl = trigger.querySelector('a') || trigger;
      linkEl.setAttribute('aria-expanded', 'false');
    });
    activePanel = null;
  };
  var showPanel = panel => {
    if (activePanel === panel) return;
    hideAllPanels(); // <-- INSTANT CLOSE (fix)
    panel.classList.remove('tw-hidden');
    activePanel = panel;
    var id = panel.dataset.megamenuId;
    var activeTrigger = header.querySelector("[data-megamenu-trigger=\"".concat(id, "\"]"));
    if (activeTrigger) {
      var linkEl = activeTrigger.querySelector('a') || activeTrigger;
      linkEl.setAttribute('aria-expanded', 'true');
    }
  };
  var insidePanel = false;
  var insideTrigger = false;
  triggers.forEach(trigger => {
    var id = trigger.dataset.megamenuTrigger;
    if (!id) return;
    var panel = header.querySelector("[data-megamenu-desktop][data-megamenu-id=\"".concat(id, "\"]"));
    if (!panel) return;

    // Find the actual clickable element (usually an <a> tag inside the trigger)
    var linkElement = trigger.querySelector('a') || trigger;

    // -----------------------------------
    // Prevent default navigation for megamenu triggers
    // -----------------------------------
    // Prevent click navigation (megamenu triggers should open menu, not navigate)
    if (linkElement.tagName === 'A') {
      linkElement.addEventListener('click', e => {
        // Always prevent navigation for megamenu triggers
        e.preventDefault();
        e.stopPropagation();
        // Toggle panel on click
        if (activePanel === panel) {
          hideAllPanels();
          trigger.classList.remove('is-active');
        } else {
          insideTrigger = true;
          showPanel(panel);
          trigger.classList.add('is-active');
        }
      });
    }

    // -----------------------------------
    // Hover Trigger → Open panel
    // -----------------------------------
    trigger.addEventListener('mouseenter', () => {
      insideTrigger = true;
      showPanel(panel);
      trigger.classList.add('is-active');
    });
    trigger.addEventListener('mouseleave', () => {
      insideTrigger = false;
      trigger.classList.remove('is-active');
      setTimeout(() => {
        if (!insideTrigger && !insidePanel) hideAllPanels();
      }, 80);
    });

    // -----------------------------------
    // Keyboard navigation (Enter/Space to toggle, not on focus)
    // ROOT FIX: Single centralized keyboard handler for accessibility
    // -----------------------------------

    // Centralized keyboard handler - single source of truth
    var handleKeyboardAccessibility = e => {
      var _target$getAttribute;
      var isMenuOpen = activePanel === panel && !panel.classList.contains('tw-hidden');
      var isTriggerFocused = document.activeElement === linkElement;
      var isInsidePanel = panel.contains(document.activeElement);
      var target = e.target;
      var isMegamenuLink = target.tagName === 'A' && ((_target$getAttribute = target.getAttribute('href')) === null || _target$getAttribute === void 0 ? void 0 : _target$getAttribute.includes('#megamenu-'));

      // Escape: Always close menu
      if (e.key === 'Escape' && isMenuOpen) {
        e.preventDefault();
        e.stopPropagation();

        // Check if this is a condensed megamenu and focus is inside active panel
        var isCondensedMegamenu = panel.querySelector('[data-megamenu-panel]') !== null;
        if (isCondensedMegamenu && isInsidePanel) {
          // For condensed megamenu: return focus to trigger
          hideAllPanels();
          trigger.classList.remove('is-active');
          insidePanel = false;
          linkElement.focus();
          return;
        }

        // Default behavior for non-condensed or when focus is on trigger
        hideAllPanels();
        trigger.classList.remove('is-active');
        insidePanel = false;
        linkElement.focus();
        return;
      }

      // Enter/Space: Toggle menu
      if (e.key === 'Enter' || e.key === ' ') {
        // Case 1: Focus is on trigger link
        if (isTriggerFocused) {
          e.preventDefault();
          e.stopPropagation();
          if (isMenuOpen) {
            // Second Enter: Close menu
            hideAllPanels();
            trigger.classList.remove('is-active');
            insideTrigger = false;
            insidePanel = false;
            linkElement.focus();
          } else {
            // First Enter: Open menu (keep focus on trigger)
            insideTrigger = true;
            showPanel(panel);
            trigger.classList.add('is-active');
            // Focus stays on trigger - user must press Tab to move to first item
          }
          return;
        }

        // Case 2: Focus is inside panel and menu is open
        if (isInsidePanel && isMenuOpen) {
          // If it's a megamenu link, close current menu (second Enter behavior)
          if (isMegamenuLink) {
            e.preventDefault();
            e.stopPropagation();
            hideAllPanels();
            trigger.classList.remove('is-active');
            insidePanel = false;
            linkElement.focus();
            return;
          }
          // For regular links, let them navigate normally
          return;
        }
      }

      // Tab: Handle navigation from trigger to first menu item, or from last item to next nav link
      // Re-check menu state to ensure it's current (in case it changed)
      var currentMenuOpen = activePanel === panel && !panel.classList.contains('tw-hidden');
      if (e.key === 'Tab' && !e.shiftKey && currentMenuOpen) {
        // Case 1: Focus is on trigger - move to first menu item
        // Re-check trigger focus state to ensure it's current
        var currentTriggerFocused = document.activeElement === linkElement;
        if (currentTriggerFocused) {
          // Ensure panel is actually visible before trying to focus inside it
          if (panel.classList.contains('tw-hidden')) {
            // Panel is hidden, allow normal Tab behavior
            return;
          }
          e.preventDefault();
          e.stopPropagation();

          // Check if this is a condensed megamenu
          var _isCondensedMegamenu = panel.querySelector('[data-megamenu-panel]') !== null;
          if (_isCondensedMegamenu) {
            // For condensed megamenu: move to first first-level button (tab button)
            var firstLevelButtons = panel.querySelectorAll('[data-megamenu-tab]');
            var visibleFirstLevelButton = Array.from(firstLevelButtons).find(button => {
              var style = window.getComputedStyle(button);
              var rect = button.getBoundingClientRect();
              return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0 && !button.closest('[hidden]');
            });
            if (visibleFirstLevelButton) {
              // Close ALL active panels and buttons to prevent edge cases
              var allActiveButtons = panel.querySelectorAll('[data-megamenu-tab].is-active');
              allActiveButtons.forEach(button => {
                button.classList.remove('is-active');
                var tabId = button.getAttribute('data-megamenu-tab');
                var correspondingPanel = panel.querySelector("[data-megamenu-panel=\"".concat(tabId, "\"]"));
                if (correspondingPanel) {
                  correspondingPanel.classList.remove('is-active');
                }
              });

              // Also close any active panels that might not have corresponding buttons
              var allActivePanels = panel.querySelectorAll('[data-megamenu-panel].is-active');
              allActivePanels.forEach(activePanel => {
                activePanel.classList.remove('is-active');
              });
              visibleFirstLevelButton.focus();
              insidePanel = true;
              return;
            }
          } else {
            // For non-condensed megamenu: move to first focusable element in panel
            // First, try to find direct links/buttons (first-level items)
            var focusableElements = panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
            var visibleFocusable = Array.from(focusableElements).filter(el => {
              // Exclude trigger and linkElement
              if (el === linkElement || trigger.contains(el)) return false;
              // Exclude nested menu toggles that are inside nested menus (they'll be handled by their own handlers)
              // But include first-level menu toggles that are direct children of the panel
              var style = window.getComputedStyle(el);
              var rect = el.getBoundingClientRect();
              return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0 && !el.closest('[hidden]');
            });
            if (visibleFocusable.length > 0) {
              // Focus the first visible focusable element
              // Use requestAnimationFrame to ensure DOM is ready and panel is fully visible
              requestAnimationFrame(() => {
                visibleFocusable[0].focus();
              });
              insidePanel = true;
              return;
            }

            // If no focusable elements found, allow normal Tab behavior
            // This shouldn't happen, but provides fallback
          }
          return;
        }

        // Case 2: Focus is inside panel - handle navigation
        if (isInsidePanel) {
          var _isCondensedMegamenu2 = panel.querySelector('[data-megamenu-panel]') !== null;
          var currentFocus = document.activeElement;

          // Check if focus is on a first-level button (tab button)
          var isFirstLevelButton = currentFocus.hasAttribute('data-megamenu-tab');
          if (_isCondensedMegamenu2 && isFirstLevelButton) {
            var _activePanel = panel.querySelector('[data-megamenu-panel].is-active');

            // Only intercept Tab if there's an active panel
            if (_activePanel) {
              // Tab from first-level button: move to first focusable element in active panel
              e.preventDefault();
              e.stopPropagation();
              var _focusableElements = _activePanel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
              var _visibleFocusable = Array.from(_focusableElements).filter(el => {
                if (el === linkElement || trigger.contains(el)) return false;
                var style = window.getComputedStyle(el);
                var rect = el.getBoundingClientRect();
                return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0 && !el.closest('[hidden]');
              });
              if (_visibleFocusable.length > 0) {
                _visibleFocusable[0].focus();
                return;
              }
            }
            // If no active panel, Tab should move to next first-level button
            // Handle this explicitly to ensure proper navigation
            e.preventDefault();
            e.stopPropagation();
            var _firstLevelButtons = panel.querySelectorAll('[data-megamenu-tab]');
            var visibleButtons = Array.from(_firstLevelButtons).filter(button => {
              var style = window.getComputedStyle(button);
              var rect = button.getBoundingClientRect();
              return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0 && !button.closest('[hidden]');
            });
            var currentButtonIndex = visibleButtons.indexOf(currentFocus);
            if (currentButtonIndex >= 0 && currentButtonIndex < visibleButtons.length - 1) {
              // Move to next first-level button
              visibleButtons[currentButtonIndex + 1].focus();
              return;
            }
            // If on last first-level button, fall through to exit logic
          }

          // Handle Tab on last item - different logic for condensed vs non-condensed
          if (_isCondensedMegamenu2) {
            // For condensed megamenu: check if we're on last item WITHIN the active panel
            var _activePanel2 = panel.querySelector('[data-megamenu-panel].is-active');
            if (_activePanel2 && _activePanel2.contains(currentFocus)) {
              // We're inside an active panel - check if we're on the last item in that panel
              var panelFocusableElements = _activePanel2.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
              var visiblePanelFocusable = Array.from(panelFocusableElements).filter(el => {
                if (el === linkElement || trigger.contains(el)) return false;
                var style = window.getComputedStyle(el);
                var rect = el.getBoundingClientRect();
                return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0 && !el.closest('[hidden]');
              });
              var currentIndex = visiblePanelFocusable.indexOf(currentFocus);
              var isLastItemInPanel = currentIndex === visiblePanelFocusable.length - 1;
              if (isLastItemInPanel) {
                // Last item in active panel - move to next first-level button
                e.preventDefault();
                e.stopPropagation();
                var _firstLevelButtons2 = panel.querySelectorAll('[data-megamenu-tab]');
                var _visibleButtons = Array.from(_firstLevelButtons2).filter(button => {
                  var style = window.getComputedStyle(button);
                  var rect = button.getBoundingClientRect();
                  return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0 && !button.closest('[hidden]');
                });

                // Find which button corresponds to current active panel
                var activePanelId = _activePanel2.getAttribute('data-megamenu-panel');
                var _currentButtonIndex = _visibleButtons.findIndex(btn => btn.getAttribute('data-megamenu-tab') === activePanelId);

                // Move to next first-level button
                if (_currentButtonIndex >= 0 && _currentButtonIndex < _visibleButtons.length - 1) {
                  _visibleButtons[_currentButtonIndex + 1].focus();
                  return;
                }

                // If no more buttons, exit megamenu normally (fall through to exit logic)
              } else {
                // Not last item in panel - allow normal Tab navigation
                return;
              }
            }
            // If not inside active panel (shouldn't happen, but handle gracefully)
            // Fall through to exit logic
          } else {
            // For non-condensed megamenu: check if we're on last item in entire panel
            var _focusableElements2 = panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
            var _visibleFocusable2 = Array.from(_focusableElements2).filter(el => {
              if (el === linkElement || trigger.contains(el)) return false;
              var style = window.getComputedStyle(el);
              var rect = el.getBoundingClientRect();
              return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0 && !el.closest('[hidden]');
            });
            var _currentIndex = _visibleFocusable2.indexOf(currentFocus);
            var isLastItem = _currentIndex === _visibleFocusable2.length - 1;
            if (!isLastItem) {
              // Not last item - allow normal Tab navigation
              return;
            }
            // If last item, fall through to exit logic
          }

          // Exit megamenu (for both condensed and non-condensed when on last item)
          e.preventDefault();
          e.stopPropagation();
          var allNavLinks = Array.from(header.querySelectorAll('.site-header__nav-link'));
          var triggersArray = Array.from(triggers);
          var currentTriggerIndex = triggersArray.indexOf(trigger);
          var _loop = function _loop() {
              var nextTrigger = triggersArray[i];
              var nextLink = nextTrigger.querySelector('.site-header__nav-link');
              if (nextLink) {
                hideAllPanels();
                trigger.classList.remove('is-active');
                insidePanel = false;
                setTimeout(() => {
                  nextLink.focus();
                }, 0);
                return {
                  v: void 0
                };
              }
            },
            _ret;
          for (var i = currentTriggerIndex + 1; i < triggersArray.length; i++) {
            _ret = _loop();
            if (_ret) return _ret.v;
          }
          var currentLinkIndex = allNavLinks.indexOf(linkElement);
          if (currentLinkIndex < allNavLinks.length - 1) {
            hideAllPanels();
            trigger.classList.remove('is-active');
            insidePanel = false;
            setTimeout(() => {
              allNavLinks[currentLinkIndex + 1].focus();
            }, 0);
          }
        }
      }

      // Shift+Tab: Handle navigation from first item back to trigger or first-level button
      if (e.key === 'Tab' && e.shiftKey && isMenuOpen) {
        var _currentFocus = document.activeElement;
        var _isCondensedMegamenu3 = panel.querySelector('[data-megamenu-panel]') !== null;

        // Check if focus is inside active panel (for condensed megamenu)
        if (_isCondensedMegamenu3) {
          var _activePanel3 = panel.querySelector('[data-megamenu-panel].is-active');
          if (_activePanel3 && _activePanel3.contains(_currentFocus)) {
            var _focusableElements3 = _activePanel3.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
            var _visibleFocusable3 = Array.from(_focusableElements3).filter(el => {
              if (el === linkElement || trigger.contains(el)) return false;
              var style = window.getComputedStyle(el);
              var rect = el.getBoundingClientRect();
              return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0 && !el.closest('[hidden]');
            });
            if (_visibleFocusable3.length > 0) {
              var firstElement = _visibleFocusable3[0];
              var isFirstElementFocused = _currentFocus === firstElement;

              // If Shift+Tab on first element, move focus back to first-level button (the one that triggered)
              // and close the active panel
              if (isFirstElementFocused) {
                e.preventDefault();
                e.stopPropagation();

                // Find the first-level button that corresponds to the active panel
                var _activePanelId = _activePanel3.getAttribute('data-megamenu-panel');
                var correspondingButton = panel.querySelector("[data-megamenu-tab=\"".concat(_activePanelId, "\"]"));
                if (correspondingButton) {
                  // Close the active panel by removing is-active class
                  _activePanel3.classList.remove('is-active');
                  correspondingButton.classList.remove('is-active');
                  correspondingButton.focus();
                  insidePanel = false;
                  return;
                }
              }
            }
          }
        }

        // Check if focus is on first item in panel (fallback for non-condensed)
        if (panel.contains(_currentFocus)) {
          var _focusableElements4 = panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
          var _visibleFocusable4 = Array.from(_focusableElements4).filter(el => {
            if (el === linkElement || trigger.contains(el)) return false;
            var style = window.getComputedStyle(el);
            var rect = el.getBoundingClientRect();
            return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0 && !el.closest('[hidden]');
          });
          if (_visibleFocusable4.length > 0) {
            var _firstElement = _visibleFocusable4[0];
            var _isFirstElementFocused = _currentFocus === _firstElement;

            // If Shift+Tab on first element, move focus back to trigger
            if (_isFirstElementFocused) {
              e.preventDefault();
              e.stopPropagation();
              linkElement.focus();
              insidePanel = false;
            }
          }
        }
      }
    };

    // Attach single keyboard handler to both trigger and panel
    linkElement.addEventListener('keydown', handleKeyboardAccessibility);
    panel.addEventListener('keydown', handleKeyboardAccessibility);
    linkElement.addEventListener('focusout', e => {
      // Only close if focus is moving outside the trigger and panel
      var relatedTarget = e.relatedTarget;
      // Allow focus to move into the panel - don't close if focus is moving to panel content
      if (relatedTarget && panel.contains(relatedTarget)) {
        // Focus moved into the panel - keep it open
        insidePanel = true;
        return;
      }
      if (!panel.contains(relatedTarget) && relatedTarget !== trigger && relatedTarget !== linkElement) {
        insideTrigger = false;
        setTimeout(() => {
          if (!insideTrigger && !insidePanel) {
            hideAllPanels();
            trigger.classList.remove('is-active');
          }
        }, 80);
      }
    });

    // Handle focusout on panel to detect when focus leaves the panel
    panel.addEventListener('focusout', e => {
      var relatedTarget = e.relatedTarget;
      if (!relatedTarget) return;

      // Check if focus is moving to another navigation element in the header
      var isMovingToNavLink = relatedTarget.classList.contains('site-header__nav-link') || relatedTarget.closest('.site-header__nav-link');
      var isMovingToNavItem = relatedTarget.closest('.site-header__nav-item');
      var isMovingToMenuTrigger = relatedTarget.closest('[data-megamenu-trigger]');
      var isMovingToHeaderNav = relatedTarget.closest('.site-header__nav');

      // If focus is moving to any header navigation element (nav-link, nav-item, or another menu trigger), allow it
      if (isMovingToNavLink || isMovingToNavItem || isMovingToMenuTrigger || isMovingToHeaderNav) {
        // Focus is moving to another navigation element - close current panel
        insidePanel = false;
        hideAllPanels();
        trigger.classList.remove('is-active');
        return;
      }

      // If focus is moving outside the panel and not to any header navigation element, close the panel
      if (!panel.contains(relatedTarget) && relatedTarget !== linkElement && !trigger.contains(relatedTarget)) {
        insidePanel = false;
        setTimeout(() => {
          if (!insideTrigger && !insidePanel) {
            hideAllPanels();
            trigger.classList.remove('is-active');
          }
        }, 80);
      }
    });

    // -----------------------------------
    // Keep panel open while mouse is inside
    // -----------------------------------
    panel.addEventListener('mouseenter', () => {
      insidePanel = true;
      trigger.classList.add('is-active');
      showPanel(panel);
    });
    panel.addEventListener('mouseleave', () => {
      insidePanel = false;
      trigger.classList.remove('is-active');
      setTimeout(() => {
        if (!insideTrigger && !insidePanel) hideAllPanels();
      }, 80);
    });
  });
}

/**
 * Initialize mobile sliding panel navigation (panel-based).
 */
function initMobileNestedNav() {
  var root = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  var drawer = root.querySelector('[data-slide-panel-root]');
  if (!drawer) return;
  var navRoot = drawer.querySelector('[data-slide-panels]');
  if (!navRoot || navRoot.dataset.mobileNavInitialized === 'true') return;
  navRoot.dataset.mobileNavInitialized = 'true';
  var panelsContainer = navRoot;
  if (!panelsContainer) return;

  /**
   * Set the active panel by id, sliding all others out of view.
   * Uses translate-x-0 for active, translate-x-full for others.
   */
  var currentActiveId = 'root';
  var currentDepth = 0;
  function setActivePanel(panelId) {
    var panels = panelsContainer.querySelectorAll('[data-slide-panel]');
    var newPanel = panelsContainer.querySelector("[data-panel-id=\"".concat(panelId, "\"]"));
    if (!newPanel) return;
    var newDepth = Number(newPanel.dataset.panelDepth || 0);
    var isForward = newDepth > currentDepth;
    var fromId = currentActiveId;
    currentActiveId = panelId;
    currentDepth = newDepth;
    panels.forEach(panel => {
      var id = panel.dataset.panelId;
      if (id === fromId) {
        // Previously active panel
        panel.classList.remove('tw-translate-x-0');
        if (isForward) {
          // Going deeper: push previous panel LEFT
          panel.classList.remove('tw-translate-x-full');
          panel.classList.add('tw-translate-x-[-100%]');
        } else {
          // Going back: push previous panel RIGHT
          panel.classList.remove('tw-translate-x-[-100%]');
          panel.classList.add('tw-translate-x-full');
        }
        panel.style.zIndex = 20;
        panel.setAttribute('aria-hidden', 'true');
        return;
      }
      if (id === panelId) {
        // New active panel
        panel.classList.remove('tw-translate-x-full', 'tw-translate-x-[-100%]');
        panel.classList.add('tw-translate-x-0');
        panel.style.zIndex = 30;
        panel.setAttribute('aria-hidden', 'false');
        return;
      }
    });
  }
  window.setActivePanel = setActivePanel;
  window.closePanel = closePanel;
  window.getCurrentActivePanel = () => {
    return currentActiveId;
  };
  function closePanel(panelId) {
    var panels = panelsContainer.querySelectorAll('[data-slide-panel]');
    var panel = panelsContainer.querySelector("[data-panel-id=\"".concat(panelId, "\"]"));
    if (!panel) return;
    panel.classList.add('tw-translate-x-full');
    panel.style.zIndex = 20;
    panel.setAttribute('aria-hidden', 'true');
  }

  // Nav forward: clicking a link or button with data-panel-target
  panelsContainer.addEventListener('click', function (e) {
    var navTrigger = e.target.closest('[data-panel-target]');
    if (navTrigger) {
      e.preventDefault();
      var targetId = navTrigger.getAttribute('data-panel-target');
      if (targetId) {
        setActivePanel(targetId);
      }
      return;
    }
    // Nav back: clicking back button
    var backBtn = e.target.closest('[data-mobile-nav-back][data-panel-parent]');
    if (backBtn) {
      e.preventDefault();
      var parentId = backBtn.getAttribute('data-panel-parent');
      if (parentId) {
        setActivePanel(parentId);
      }
      return;
    }
  });

  // Optional: swipe to navigate back (touch events)
  var touchStartX = null;
  panelsContainer.addEventListener('touchstart', function (e) {
    if (e.touches.length === 1) {
      touchStartX = e.touches[0].clientX;
    }
  });
  panelsContainer.addEventListener('touchend', function (e) {
    if (touchStartX !== null && e.changedTouches.length === 1) {
      var dx = e.changedTouches[0].clientX - touchStartX;
      // Simple heuristic: swipe right
      if (dx > 60) {
        // Find visible panel and trigger back
        var activePanel = panelsContainer.querySelector('.slide-panel.tw-translate-x-0');
        var backBtn = activePanel && activePanel.querySelector('[data-mobile-nav-back][data-panel-parent]');
        if (backBtn) backBtn.click();
      }
    }
    touchStartX = null;
  });
}
/**
 * Initialize desktop hover menu
 */
function initHoverNestedMenu() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$toggleAttr = _ref.toggleAttr,
    toggleAttr = _ref$toggleAttr === void 0 ? 'data-menu-toggle' : _ref$toggleAttr,
    _ref$menuAttr = _ref.menuAttr,
    menuAttr = _ref$menuAttr === void 0 ? 'data-nested-menu' : _ref$menuAttr,
    _ref$activeClass = _ref.activeClass,
    activeClass = _ref$activeClass === void 0 ? 'is-active' : _ref$activeClass,
    _ref$parentEl = _ref.parentEl,
    parentEl = _ref$parentEl === void 0 ? 'data-nested-menu-parent' : _ref$parentEl,
    _ref$forceVisible = _ref.forceVisible,
    forceVisible = _ref$forceVisible === void 0 ? false : _ref$forceVisible;
  var toggles = document.querySelectorAll("[".concat(toggleAttr, "]"));
  toggles.forEach(toggle => {
    var parent = toggle.closest("[".concat(parentEl, "]"));
    var nestedMenu = parent === null || parent === void 0 ? void 0 : parent.querySelector("[".concat(menuAttr, "]"));
    //handle for nested menu
    if (toggle.dataset.megamenuTab) {
      var megamenuId = toggle.dataset.megamenuTab;
      nestedMenu = parent === null || parent === void 0 ? void 0 : parent.querySelector("[data-megamenu-panel=\"".concat(megamenuId, "\"]"));
    }
    if (!nestedMenu) return;

    // Find the actual focusable element (usually an <a> tag inside the toggle)
    var linkElement = toggle.querySelector('a') || toggle;
    var hoverInside = false;
    var hideAllPanels = () => {
      parent.querySelectorAll("[".concat(menuAttr, "]")).forEach(menu => {
        if (menu.classList.remove(activeClass)) {
          menu.classList.remove(activeClass);
        }
      });
    };
    var removeActiveClassFromToggle = () => {
      parent.querySelectorAll("[".concat(toggleAttr, "]")).forEach(toggle => {
        if (toggle.classList.remove(activeClass)) {
          toggle.classList.remove(activeClass);
        }
      });
    };
    var showMenu = () => {
      hideAllPanels();
      removeActiveClassFromToggle();
      nestedMenu.classList.add(activeClass);
      toggle.classList.add(activeClass);
    };
    var hideMenu = () => {
      // Note: This function does NOT handle focus - focus is only managed for keyboard accessibility
      if (!hoverInside && !forceVisible) {
        toggle.classList.remove(activeClass);
        nestedMenu.classList.remove(activeClass);
      }
    };

    // Hover on the toggle opens the menu
    toggle.addEventListener('mouseenter', () => {
      hoverInside = true;
      showMenu();
    });
    toggle.addEventListener('mouseleave', () => {
      hoverInside = false;
      setTimeout(hideMenu, 50); // Small delay prevents flicker
    });

    // Shared Escape handler - works from both toggle and nested menu (like megamenu pattern)
    var handleEscape = e => {
      if (e.key !== 'Escape') return;

      // Only handle escape if this nested menu is actually open
      var isMenuOpen = nestedMenu.classList.contains(activeClass);
      if (!isMenuOpen) return;

      // Check if we're inside a megamenu - if so, let megamenu handler take precedence
      var isInsideMegamenu = toggle.closest('[data-megamenu-desktop]') || toggle.closest('[data-megamenu-trigger]') || nestedMenu.closest('[data-megamenu-desktop]');

      // If inside megamenu and megamenu is open, don't handle here - let event bubble to megamenu handler
      if (isInsideMegamenu) {
        var megamenuPanel = nestedMenu.closest('[data-megamenu-desktop]');
        if (megamenuPanel && !megamenuPanel.classList.contains('tw-hidden')) {
          // Don't prevent default or stop propagation - let megamenu handler catch it
          return; // Let megamenu handler deal with it
        }
      }

      // Not inside megamenu (or megamenu is closed) - handle Escape here
      e.preventDefault();
      e.stopPropagation();
      hoverInside = false;
      // Directly close menu (bypass forceVisible for keyboard accessibility)
      toggle.classList.remove(activeClass);
      nestedMenu.classList.remove(activeClass);
      linkElement.focus(); // Keyboard-only: Return focus to trigger link for accessibility
    };

    // Keyboard navigation (Enter/Space to open, not on focus) - only on toggle
    toggle.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        var isMenuOpen = nestedMenu.classList.contains(activeClass);
        if (isMenuOpen) {
          // Menu is open - close it (bypass forceVisible for keyboard)
          hoverInside = false;
          toggle.classList.remove(activeClass);
          nestedMenu.classList.remove(activeClass);
          linkElement.focus(); // Keyboard-only: Return focus to trigger link for accessibility
        } else {
          // Menu is closed - open it
          hoverInside = true;
          showMenu();
        }
      }
    });

    // Attach Escape handler to both toggle and nested menu (like megamenu does)
    toggle.addEventListener('keydown', handleEscape);
    nestedMenu.addEventListener('keydown', handleEscape);
    toggle.addEventListener('focusout', e => {
      var relatedTarget = e.relatedTarget;
      if (!nestedMenu.contains(relatedTarget) && relatedTarget !== toggle) {
        hoverInside = false;
        setTimeout(hideMenu, 50);
      }
    });

    // Hover inside nested menu keeps it active
    nestedMenu.addEventListener('mouseenter', () => {
      hoverInside = true;
      showMenu();
    });

    // Leaving nested menu: only hide if not entering the toggle
    nestedMenu.addEventListener('mouseleave', () => {
      hoverInside = false;
      setTimeout(hideMenu, 50);
    });
  });
}
var initHeaderSearch = () => {
  var searchParent = document.querySelectorAll('[data-search-parent]');
  if (!searchParent.length) return;
  searchParent.forEach(parent => {
    var searchPlaceholder = parent.querySelector('[data-search-placeholder]');
    var showSearchPlaceholder = () => {
      if (!searchPlaceholder) return;
      searchPlaceholder.style.display = 'flex';
    };
    var hideSearchPlaceholder = () => {
      if (!searchPlaceholder) return;
      searchPlaceholder.style.display = 'none';
    };
    var handleSearch = /*#__PURE__*/function () {
      var _ref2 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* (ev) {
        searchResults.innerHTML = '';
        if (ev.target.value.length <= 0) {
          trendingSearches.style.display = 'block';
          searchResults.innerHTML = '';
          hideSearchPlaceholder();
          return;
        }
        trendingSearches.style.display = 'none';
        showSearchPlaceholder();
        var query = ev.target.value;
        var results = yield (0,JsComponents_header_search_js__WEBPACK_IMPORTED_MODULE_1__.getHeaderSearch)(query);
        var html = results["header-search"];
        hideSearchPlaceholder();
        searchResults.innerHTML = html;
      });
      return function handleSearch(_x) {
        return _ref2.apply(this, arguments);
      };
    }();
    var handleTrendingSearchClick = ev => {
      var trendingSearchItem = ev.target.closest('[data-trending-search-item]');
      if (trendingSearchItem) {
        var query = trendingSearchItem.dataset.trendingSearchItem;
        searchInput.value = query;
        searchInput.dispatchEvent(new Event('input'));
      }
    };
    var searchInput = parent.querySelector('[data-search-input]');
    if (!searchInput) return;
    var searchResults = parent.querySelector('[data-search-results]');
    if (!searchResults) return;
    var trendingSearches = parent.querySelector('[data-trending-searches]');
    if (trendingSearches) {
      trendingSearches.addEventListener('click', handleTrendingSearchClick);
    }
    searchInput.addEventListener('input', (0,JsComponents_header_search_js__WEBPACK_IMPORTED_MODULE_1__.debounce)(handleSearch, 500));
    var mobileSearchInput = parent.querySelector('[data-search-input-mobile]');
    if (!mobileSearchInput) return;
    mobileSearchInput.addEventListener('focus', () => {
      if (getCurrentActivePanel() !== 'search') {
        setActivePanel('search');
      }
    });
  });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (function () {
  var root = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  initHeaderMegamenu(root);
  initMobileNestedNav(root);
  initHoverNestedMenu();
  initHoverNestedMenu({
    toggleAttr: "data-megamenu-tab",
    forceVisible: true
  });
  initHeaderSearch();
});
__webpack_require__.dn(__WEBPACK_DEFAULT_EXPORT__);

/***/ },

/***/ "./js/components/migrate-section.js"
/*!******************************************!*\
  !*** ./js/components/migrate-section.js ***!
  \******************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   appendSection: () => (/* binding */ appendSection),
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
var migrateSection = () => {
  var sections = document.querySelectorAll('[data-migrate-section]');
  sections.forEach(section => {
    var sectionId = section.dataset.migrateSection;
    if (sectionId) {
      var query = "[data-section-target=\"".concat(sectionId, "\"]");
      var targetSection = document.querySelectorAll(query);
      targetSection.forEach(target => {
        target.innerHTML = section.innerHTML;
        section.setAttribute('data-migrated', '');
        section.style.display = 'none';
        // section.remove();
      });
    }
  });
};
var appendSection = () => {
  var sections = document.querySelectorAll('[data-append-section]');
  sections.forEach(section => {
    var sectionId = section.dataset.appendSection;
    if (sectionId) {
      var query = "[data-section-target=\"".concat(sectionId, "\"]");
      var targetSection = document.querySelectorAll(query);
      targetSection.forEach(target => {
        target.insertAdjacentHTML('beforeend', section.innerHTML);
        section.remove();
      });
    }
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (migrateSection);

/***/ },

/***/ "./js/components/myapp-header.js"
/*!***************************************!*\
  !*** ./js/components/myapp-header.js ***!
  \***************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ initMyAppHeader)
/* harmony export */ });
var MODAL_ID = 'modal-instructions-header';
var DRAWER_ID = 'header-mobile-drawer';
var MOBILE_BREAKPOINT = 1068;
var DRAWER_CLOSE_DELAY = 350;
var MODAL_OPEN_DELAY = 100;
var TOUCH_LOCK_TIME = 400;

// Helpers

var isMobileView = () => window.innerWidth < MOBILE_BREAKPOINT;
var getDrawer = () => document.getElementById(DRAWER_ID);
var getModal = () => document.getElementById(MODAL_ID);
var getBackdrop = () => document.querySelector('.tw-bg-black.tw-bg-opacity-50');

// Drawer handling

function closeMobileDrawer(onClosed) {
  var drawer = getDrawer();
  if (!drawer || drawer.classList.contains('tw-hidden')) {
    onClosed === null || onClosed === void 0 || onClosed();
    return;
  }
  var closeBtn = document.querySelector("[data-drawer-hide=\"".concat(DRAWER_ID, "\"]"));
  if (!closeBtn) {
    onClosed === null || onClosed === void 0 || onClosed();
    return;
  }
  closeBtn.click();
  setTimeout(() => onClosed === null || onClosed === void 0 ? void 0 : onClosed(), DRAWER_CLOSE_DELAY);
}

// Modal handling

function openModal() {
  var _getBackdrop, _modal$querySelector;
  var modal = getModal();
  if (!modal) return;
  modal.classList.remove('tw-hidden');
  (_getBackdrop = getBackdrop()) === null || _getBackdrop === void 0 || _getBackdrop.classList.remove('tw-hidden');
  document.body.style.overflow = 'hidden';

  // Focus management (basic accessibility)
  (_modal$querySelector = modal.querySelector('button, [tabindex]')) === null || _modal$querySelector === void 0 || _modal$querySelector.focus();
}
function openModalSafely() {
  if (!isMobileView()) {
    openModal();
    return;
  }
  closeMobileDrawer(() => {
    requestAnimationFrame(() => {
      setTimeout(openModal, MODAL_OPEN_DELAY);
    });
  });
}

// Init

function initMyAppHeader() {
  var isTouchLocked = false;
  function handleTrigger(event) {
    var trigger = event.target.closest('[data-myapp-header]');
    if (!trigger) return;

    // If modal doesn't exist, let the <a> navigate normally
    if (!getModal()) return;
    if (event.type === 'touchend') {
      event.preventDefault();
      isTouchLocked = true;
      setTimeout(() => isTouchLocked = false, TOUCH_LOCK_TIME);
    }
    if (event.type === 'click' && isTouchLocked) return;
    event.preventDefault();
    openModalSafely();
  }
  document.addEventListener('click', handleTrigger);
  document.addEventListener('touchend', handleTrigger, {
    passive: false
  });
}

/***/ },

/***/ "./js/components/qualifier.js"
/*!************************************!*\
  !*** ./js/components/qualifier.js ***!
  \************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ initQualifierGroups)
/* harmony export */ });
function initQualifierGroups() {
  var groups = document.querySelectorAll('[data-qualifier-group]');
  groups.forEach(blockEl => {
    if (blockEl.dataset.qualifierInitialized === 'true') return;
    blockEl.dataset.qualifierInitialized = 'true';
    var qualifiedUrl = blockEl.dataset.qualifiedUrl;
    var getAnswer = n => {
      var questionEl = blockEl.querySelector("[data-qualifier-question=\"".concat(n, "\"]"));
      if (!questionEl) return null;
      var checked = questionEl.querySelector('input[type="radio"]:checked');
      return checked ? checked.value : null;
    };
    var allAnswered = () => getAnswer(1) !== null && getAnswer(2) !== null && getAnswer(3) !== null;
    var isQualified = () => getAnswer(2) === 'yes' || getAnswer(3) === 'yes';
    var form = blockEl.closest('[data-form-id]');
    var submitEl = form ? form.querySelector('[data-form-submit]') : null;

    // Enable button once all 3 questions are answered (regardless of result)
    var onRadioChange = () => {
      if (!allAnswered() || !submitEl) return;
      if (form && qualifiedUrl) form.dataset.formRedirectUrl = qualifiedUrl;
      submitEl.setAttribute('data-button-disabled', 'false');
    };

    // On button click: qualified → let form redirect flow run; not-qualified → show message
    var onButtonClick = e => {
      if (!allAnswered()) return;
      if (!isQualified()) {
        // Block the form's submit handler and show not-qualified message
        e.stopImmediatePropagation();
        e.preventDefault();
        var questionsEl = blockEl.querySelector('[data-qualifier-questions]');
        var notQualifiedEl = blockEl.querySelector('[data-qualifier-not-qualified-ui]');
        if (questionsEl) questionsEl.classList.add('tw-hidden');
        if (submitEl) submitEl.classList.add('tw-hidden');
        if (notQualifiedEl) notQualifiedEl.classList.remove('tw-hidden');
      }
      // Qualified: do nothing — form's submit handler runs next and redirects
    };
    blockEl.querySelectorAll('input[type="radio"]').forEach(radio => {
      radio.addEventListener('change', onRadioChange);
    });
    if (submitEl) {
      submitEl.addEventListener('click', onButtonClick);
    }
  });
}

/***/ },

/***/ "./js/components/scroll-tab.js"
/*!*************************************!*\
  !*** ./js/components/scroll-tab.js ***!
  \*************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
var scrollTab = () => {
  var scrollTabSections = document.querySelectorAll('[data-scroll-tabs-list]');

  // Helper function to detect mobile
  var isMobile = () => window.innerWidth < 1024;
  scrollTabSections.forEach(section => {
    var scrollTabButton = section.querySelectorAll('[data-tab]');
    var contentTargets = section.querySelectorAll('[data-section-target]');
    if (scrollTabButton.length === 0 || contentTargets.length === 0) return;

    // Track current active tab to prevent unnecessary switches
    var currentActiveTabId = null;

    // Track user-initiated clicks to prevent Intersection Observer from overriding
    var userInitiatedTabChange = false;
    var userInitiatedTimeout = null;

    // Get screen reader announcer element
    var sectionId = section.id.replace('shopify-section-', '');
    var announcer = section.querySelector("#scroll-tabs-announcer-".concat(sectionId));

    // Helper function to announce to screen readers
    var announceToScreenReader = message => {
      if (announcer) {
        announcer.textContent = message;
        // Clear after announcement to allow re-announcement
        setTimeout(() => {
          announcer.textContent = '';
        }, 1000);
      }
    };

    // Get offsets based on device type
    var getScrollOffset = () => isMobile() ? 200 : 100;
    var getObserverOffset = () => isMobile() ? '-160px 0px -50% 0px' : '-120px 0px -50% 0px';

    // Helper function to get all tab buttons in order
    var getAllTabButtons = () => {
      return Array.from(section.querySelectorAll('[data-tab]'));
    };

    // Helper function to get tab index
    var getTabIndex = button => {
      var allButtons = getAllTabButtons();
      // Remove duplicates by tab ID
      var uniqueTabIds = [...new Set(allButtons.map(btn => btn.dataset.tabButton))];
      return uniqueTabIds.indexOf(button.dataset.tabButton);
    };

    // Helper function to get tab button by index
    var getTabButtonByIndex = index => {
      var allButtons = getAllTabButtons();
      var uniqueTabIds = [...new Set(allButtons.map(btn => btn.dataset.tabButton))];
      if (index < 0 || index >= uniqueTabIds.length) return null;
      return section.querySelector("[data-tab=\"".concat(uniqueTabIds[index], "\"]"));
    };

    // Helper function to update tabindex for all buttons
    var updateTabIndexes = activeButton => {
      return;
      // removed by dead control flow
 var allButtons; 
      // removed by dead control flow
 var uniqueTabIds; 
      // removed by dead control flow

    };

    // Helper function to scroll to content and activate tab
    var scrollToTabContent = function scrollToTabContent(tabId) {
      var announce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var isUserInitiated = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var tabContentQuery = "[data-section-target=\"".concat(tabId, "\"]");
      var tabContent = section.querySelector(tabContentQuery);
      if (!tabContent) return;

      // Mark as user-initiated if it's a click
      if (isUserInitiated) {
        userInitiatedTabChange = true;
        // Clear any existing timeout
        if (userInitiatedTimeout) {
          clearTimeout(userInitiatedTimeout);
        }
        // Reset flag after scroll completes (smooth scroll takes ~500ms)
        userInitiatedTimeout = setTimeout(() => {
          userInitiatedTabChange = false;
        }, 800); // 800ms to account for scroll animation + buffer
      }
      var headerOffset = getScrollOffset();
      var elementPosition = tabContent.getBoundingClientRect().top;
      var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });

      // Debounce tab activation on click to prevent jumping
      if (isUserInitiated) {
        debouncedActivateTab(tabId, true, announce);
      } else {
        activateTabButton(tabId, true, announce);
      }
    };

    // Helper function to activate a tab button by tab_id
    var activateTabButton = function activateTabButton(tabId) {
      var scrollSwiper = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var announce = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      // Prevent switching to the same tab
      if (currentActiveTabId === tabId) return;

      // Find ALL tab buttons with this ID (there may be multiple - desktop/mobile versions)
      var tabButtons = section.querySelectorAll("[data-tab=\"".concat(tabId, "\"]"));
      if (tabButtons.length === 0) return;

      // Get tab title for screen reader announcement
      var tabTitle = tabButtons[0].getAttribute('aria-label') || tabButtons[0].textContent.trim();

      // Deactivate all tab buttons in this section
      scrollTabButton.forEach(btn => {
        btn.classList.remove('active');
      });

      // Activate ALL matching tab buttons with the same ID
      tabButtons.forEach(tabButton => {
        tabButton.classList.add('active');
      });

      // Update tabindex
      if (tabButtons.length > 0) {
        updateTabIndexes(tabButtons[0]);
      }
      currentActiveTabId = tabId;

      // Announce to screen readers
      if (announce && tabTitle) {
        announceToScreenReader("Tab activated: ".concat(tabTitle));
      }

      // Find and activate the swiper slide for ALL active buttons
      // (need to scroll all swipers - desktop and mobile)
      if (scrollSwiper && tabButtons.length > 0) {
        var processedSwipers = new WeakSet(); // Track which swiper instances we've already processed

        tabButtons.forEach(tabButton => {
          var swiperSlide = tabButton.closest('.swiper-slide');
          if (!swiperSlide) return;

          // Find the carousel-swiper custom element
          var carouselSwiper = tabButton.closest('carousel-swiper');
          var swiper = null;
          var slideIndex = -1;
          if (carouselSwiper && carouselSwiper.swiper) {
            swiper = carouselSwiper.swiper;
            slideIndex = Array.from(swiperSlide.parentElement.children).indexOf(swiperSlide);
          } else {
            // Fallback: try to find swiper instance on the container
            var swiperContainer = swiperSlide.closest('.swiper');
            if (swiperContainer && swiperContainer.swiper) {
              swiper = swiperContainer.swiper;
              slideIndex = Array.from(swiperSlide.parentElement.children).indexOf(swiperSlide);
            }
          }

          // Slide to the active tab button (only if we haven't processed this swiper instance yet)
          if (swiper && slideIndex !== -1 && !processedSwipers.has(swiper)) {
            processedSwipers.add(swiper);
            swiper.slideTo(slideIndex, 300); // 300ms animation
          }
        });
      }
    };

    // Click handler: Scroll to corresponding content section
    scrollTabButton.forEach(button => {
      button.addEventListener('click', e => {
        e.preventDefault();
        var tabId = button.dataset.tab;
        scrollToTabContent(tabId, true, true); // Mark as user-initiated
      });
    });

    // Keyboard navigation handler
    scrollTabButton.forEach(button => {
      button.addEventListener('keydown', e => {
        var allButtons = getAllTabButtons();
        var uniqueTabIds = [...new Set(allButtons.map(btn => btn.dataset.tabButton))];
        var currentIndex = getTabIndex(button);
        var targetIndex = currentIndex;
        var shouldPreventDefault = false;

        // Determine orientation based on tablist
        var tablist = button.closest('[role="tablist"]');
        var orientation = (tablist === null || tablist === void 0 ? void 0 : tablist.getAttribute('aria-orientation')) || (isMobile() ? 'horizontal' : 'vertical');
        switch (e.key) {
          case 'ArrowRight':
            if (orientation === 'horizontal') {
              targetIndex = (currentIndex + 1) % uniqueTabIds.length;
              shouldPreventDefault = true;
            }
            break;
          case 'ArrowLeft':
            if (orientation === 'horizontal') {
              targetIndex = (currentIndex - 1 + uniqueTabIds.length) % uniqueTabIds.length;
              shouldPreventDefault = true;
            }
            break;
          case 'ArrowDown':
            if (orientation === 'vertical') {
              targetIndex = (currentIndex + 1) % uniqueTabIds.length;
              shouldPreventDefault = true;
            }
            break;
          case 'ArrowUp':
            if (orientation === 'vertical') {
              targetIndex = (currentIndex - 1 + uniqueTabIds.length) % uniqueTabIds.length;
              shouldPreventDefault = true;
            }
            break;
          case 'Home':
            targetIndex = 0;
            shouldPreventDefault = true;
            break;
          case 'End':
            targetIndex = uniqueTabIds.length - 1;
            shouldPreventDefault = true;
            break;
          case 'Enter':
          case ' ':
            e.preventDefault();
            var tabId = button.dataset.tabButton;
            scrollToTabContent(tabId, true, true); // Mark as user-initiated
            return;
        }
        if (shouldPreventDefault) {
          e.preventDefault();
          var targetButton = getTabButtonByIndex(targetIndex);
          if (targetButton) {
            targetButton.focus();
            var _tabId = targetButton.dataset.tabButton;
            scrollToTabContent(_tabId, true, true); // Mark as user-initiated
          }
        }
      });
    });

    // Debounce function to prevent rapid switching
    var debounceTimeout = null;
    var debouncedActivateTab = function debouncedActivateTab(tabId) {
      var scrollSwiper = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var announce = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      clearTimeout(debounceTimeout);
      debounceTimeout = setTimeout(() => {
        activateTabButton(tabId, scrollSwiper, announce);
      }, 150); // 150ms debounce delay
    };

    // Intersection Observer: Activate tab when content section is in viewport
    var observerOptions = {
      root: null,
      rootMargin: getObserverOffset(),
      // Different offset for mobile/desktop
      threshold: [0, 0.1, 0.25, 0.5, 0.75, 1]
    };

    // Create observer callback
    var observerCallback = entries => {
      // Don't override user-initiated tab changes
      if (userInitiatedTabChange) return;

      // Find entries that are intersecting (in viewport with offset)
      var intersectingEntries = entries.filter(entry => entry.isIntersecting);
      if (intersectingEntries.length === 0) return;

      // If multiple entries are intersecting, choose the one with highest intersection ratio
      // (most visible in viewport)
      var mostVisibleEntry = null;
      var maxRatio = 0;
      intersectingEntries.forEach(entry => {
        if (entry.intersectionRatio > maxRatio) {
          maxRatio = entry.intersectionRatio;
          mostVisibleEntry = entry;
        }
      });

      // Activate the tab for the most visible intersecting entry
      if (mostVisibleEntry) {
        var tabId = mostVisibleEntry.target.getAttribute('data-section-target');
        if (tabId) {
          debouncedActivateTab(tabId); // Use debounced activation
        }
      }
    };

    // Create observer
    var observer = new IntersectionObserver(observerCallback, observerOptions);

    // Update observer on resize to use correct offset
    var resizeTimeout;
    var updateObserverOptions = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        // Disconnect current observer
        observer.disconnect();
        // Update options with new offset
        observerOptions.rootMargin = getObserverOffset();
        // Recreate observer with new options
        observer = new IntersectionObserver(observerCallback, observerOptions);
        // Re-observe all targets
        contentTargets.forEach(target => {
          observer.observe(target);
        });
      }, 250);
    };
    window.addEventListener('resize', updateObserverOptions);

    // Observe all content target elements
    contentTargets.forEach(target => {
      observer.observe(target);
    });

    // Initial check on load
    var checkInitialActive = () => {
      var offset = getScrollOffset();
      var viewportCenter = window.innerHeight / 2 + offset;
      var activeTarget = null;
      var minDistance = Infinity;
      contentTargets.forEach(target => {
        var rect = target.getBoundingClientRect();
        var targetCenter = rect.top + rect.height / 2;
        var distance = Math.abs(targetCenter - viewportCenter);

        // Check if target is in viewport and closest to center
        if (rect.top < viewportCenter && rect.bottom > viewportCenter) {
          if (distance < minDistance) {
            minDistance = distance;
            activeTarget = target;
          }
        }
      });
      if (activeTarget) {
        var tabId = activeTarget.getAttribute('data-section-target');
        if (tabId) {
          activateTabButton(tabId, true, false); // Scroll swiper to show active tab, don't announce on initial load
        }
      } else {
        var _contentTargets$;
        // If no active target, set first tab as active
        var firstTabId = (_contentTargets$ = contentTargets[0]) === null || _contentTargets$ === void 0 ? void 0 : _contentTargets$.getAttribute('data-section-target');
        if (firstTabId) {
          activateTabButton(firstTabId, true, false);
        }
      }
    };

    // Run initial check after a short delay to ensure DOM and swiper are ready
    setTimeout(checkInitialActive, 500);
  });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (scrollTab);

/***/ },

/***/ "./js/components/smooth-scroll-hash.js"
/*!*********************************************!*\
  !*** ./js/components/smooth-scroll-hash.js ***!
  \*********************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ smoothScrollHash)
/* harmony export */ });
function findHeadingSection(hash) {
  var phrase = hash.slice(1).toLowerCase().replace(/-/g, ' ');
  if (!phrase) return null;
  var heading = [...document.querySelectorAll('h1, h2, h3, h4, h5, h6')].find(h => h.textContent.toLowerCase().includes(phrase));
  return heading ? heading.closest('.shopify-section') || heading : null;
}
function findTarget(hash, wantsForm) {
  var byHash = hash && hash !== '#' ? document.getElementById(hash.slice(1)) || findHeadingSection(hash) : null;
  if (byHash || !wantsForm) return byHash;
  // ponytail: scoped to main so header/footer search & newsletter forms don't match
  var form = document.querySelector('main form');
  return form && (form.closest('.shopify-section') || form);
}
function scrollToTarget(target) {
  target.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  // ponytail: lazy images load mid-scroll and shift layout — re-align until stable
  var attempts = 0;
  var settle;
  var stop = () => clearInterval(settle);
  settle = setInterval(() => {
    if (Math.abs(target.getBoundingClientRect().top) <= 2 || ++attempts >= 10) stop();else target.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }, 400);
  // user takes over — stop fighting their scroll
  ['wheel', 'touchstart', 'keydown'].forEach(type => window.addEventListener(type, stop, {
    once: true,
    passive: true
  }));
}
function applyScrollAnchors() {
  var el = document.querySelector('[data-scroll-anchor-config]');
  if (!el) return;
  try {
    var anchors = JSON.parse(el.textContent);
    anchors.forEach(_ref => {
      var id = _ref.id,
        heading = _ref.heading;
      if (!id || !heading || document.getElementById(id)) return;
      var match = [...document.querySelectorAll('h1, h2, h3, h4, h5, h6')].find(h => h.textContent.toLowerCase().includes(heading.toLowerCase()));
      if (!match) return;
      var section = match.closest('.shopify-section') || match;
      section.id = id;
    });
  } catch (_) {/* malformed JSON — skip */}
}
function smoothScrollHash() {
  applyScrollAnchors();
  // delegated + capture phase: survives carousel clones, section reloads,
  // late-rendered links, and swiper's preventClicksPropagation
  document.addEventListener('click', e => {
    var link = e.target.closest('a[data-scroll-to-form], a[href*="#"]');
    if (!link) return;
    var wantsForm = link.hasAttribute('data-scroll-to-form');
    // respect other handlers (e.g. swiper ghost-click suppression) for plain hash links,
    // but form links always scroll — a window-capture handler preventDefaults '#' clicks
    if (e.defaultPrevented && !wantsForm) return;
    var url = new URL(link.href, location.origin);
    if (!wantsForm && url.pathname !== location.pathname && url.pathname !== '/') return;
    var target = findTarget(url.hash, wantsForm);
    if (!target && !wantsForm) return;
    e.preventDefault();
    if (!target) return;
    scrollToTarget(target);
    if (!wantsForm) history.replaceState(null, '', url.hash);
  }, true);
  if (location.hash) {
    var target = findTarget(location.hash, false);
    if (target) setTimeout(() => scrollToTarget(target), 100);
  }
}

/***/ },

/***/ "./js/components/table-scrollbar.js"
/*!******************************************!*\
  !*** ./js/components/table-scrollbar.js ***!
  \******************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ initTableScrollbar)
/* harmony export */ });
/**
 * Table Custom Scrollbar Component
 * Creates a custom scrollbar that controls table horizontal scrolling
 */
function initTableScrollbar() {
  var root = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  var tableContainers = root.querySelectorAll('[data-table-scroll]');
  tableContainers.forEach(tableContainer => {
    // Skip if already initialized
    if (tableContainer.dataset.initialized === 'true') {
      return;
    }
    tableContainer.dataset.initialized = 'true';
    var wrapper = tableContainer.closest('.table-block__wrapper');
    if (!wrapper) return;

    // Scrollbar is now outside wrapper (sibling), so find it from the parent container
    var container = wrapper.parentElement;
    var scrollbar = container ? container.querySelector('[data-table-scrollbar]') : null;
    var scrollbarTrack = scrollbar ? scrollbar.querySelector('.table-block__scrollbar-track') : null;
    var scrollbarThumb = scrollbar ? scrollbar.querySelector('[data-table-scrollbar-thumb]') : null;
    if (!scrollbar || !scrollbarTrack || !scrollbarThumb) return;
    var isDragging = false;
    var startX = 0;
    var startScrollLeft = 0;
    var lastPaddingState = null;
    var lastMarginState = null;
    var wasAtEnd = false; // Track previous end state for hysteresis
    var wasAtStart = false; // Track previous start state for hysteresis
    var rafId = null; // For requestAnimationFrame debouncing

    // iOS scroll end detection variables
    var lastScrollLeft = 0;
    var sameCount = 0;
    var STALL_FRAMES = 3;

    // iOS-specific function to detect when scroll has reached the end
    function isEndReachedIOS(el) {
      var maxScroll = el.scrollWidth - el.clientWidth;
      var current = Math.round(el.scrollLeft);

      // Must be near the end first
      if (current < maxScroll - 40) {
        sameCount = 0;
        lastScrollLeft = current;
        return false;
      }
      if (current === lastScrollLeft) {
        sameCount++;
      } else {
        sameCount = 0;
      }
      lastScrollLeft = current;
      return sameCount >= STALL_FRAMES;
    }

    // Find the table section container
    var tableSection = wrapper.closest('.table-section');
    // Find table block container with margin control attribute (now on table-block__container)
    var tableBlockContainer = container && container.hasAttribute('data-table-margin-control') ? container : null;
    // Find table-block for margin control (parent of container with data-table-margin-control)
    var tableBlock = tableBlockContainer ? tableBlockContainer.closest('.table-block') : null;

    // Get card border radius from data attribute
    var cardBorderRadius = tableContainer.dataset.cardBorderRadius || '12';

    // Helper function to set border radius on all corners
    var setBorderRadius = (topLeft, topRight, bottomLeft, bottomRight) => {
      var value = val => val + (typeof val === 'number' ? 'px' : '');
      tableContainer.style.setProperty('border-top-left-radius', value(topLeft), 'important');
      tableContainer.style.setProperty('border-top-right-radius', value(topRight), 'important');
      tableContainer.style.setProperty('border-bottom-left-radius', value(bottomLeft), 'important');
      tableContainer.style.setProperty('border-bottom-right-radius', value(bottomRight), 'important');
    };

    // Function to update wrapper border radius based on scroll position (mobile only)
    var updateWrapperBorderRadius = () => {
      var cardRadius = parseFloat(cardBorderRadius) || 12;

      // Desktop: apply border radius on all corners
      if (window.innerWidth >= 768) {
        setBorderRadius(cardRadius, cardRadius, cardRadius, cardRadius);
        return;
      }
      var scrollLeft = tableContainer.scrollLeft,
        scrollWidth = tableContainer.scrollWidth,
        clientWidth = tableContainer.clientWidth;
      var scrollableWidth = scrollWidth - clientWidth;

      // No scroll: apply border radius on all corners
      if (scrollableWidth <= 0) {
        setBorderRadius(cardRadius, cardRadius, cardRadius, cardRadius);
        return;
      }

      // Use hysteresis to prevent flickering during slow scroll
      var threshold = 2;
      var startThresholdEnter = threshold; // 2px - easy to enter start
      var startThresholdExit = threshold + 4; // 6px - harder to exit start
      var endThresholdEnter = threshold + 12; // 14px - easy to enter end
      var endThresholdExit = threshold + 8; // 10px - harder to exit end

      // Check start position with hysteresis
      var isAtStart;
      if (wasAtStart) {
        isAtStart = scrollLeft <= startThresholdExit;
      } else {
        isAtStart = scrollLeft <= startThresholdEnter;
      }

      // Check end position with hysteresis
      var distanceFromEnd = scrollWidth - (scrollLeft + clientWidth);
      var isAtEnd;
      if (wasAtEnd) {
        isAtEnd = distanceFromEnd <= endThresholdExit;
      } else {
        isAtEnd = distanceFromEnd <= endThresholdEnter;
      }
      wasAtStart = isAtStart;
      wasAtEnd = isAtEnd;

      // Apply border radius based on position
      if (isAtStart) {
        setBorderRadius(cardRadius, 0, cardRadius, 0); // Left side only
      } else if (isAtEnd) {
        setBorderRadius(0, cardRadius, 0, cardRadius); // Right side only
      } else {
        setBorderRadius(0, 0, 0, 0); // No border radius
      }
    };

    // Update scrollbar thumb position and size
    // Batches all DOM reads first, then all writes to avoid forced reflows.
    var updateScrollbar = () => {
      // --- BATCH ALL READS ---
      var scrollLeft = tableContainer.scrollLeft,
        scrollWidth = tableContainer.scrollWidth,
        clientWidth = tableContainer.clientWidth;
      var trackWidth = scrollbarTrack.offsetWidth + 12;
      var viewportWidth = window.innerWidth;
      var scrollableWidth = scrollWidth - clientWidth;
      if (scrollableWidth <= 0) {
        // --- BATCH ALL WRITES (no-scroll case) ---
        scrollbar.style.display = 'none';
        if (tableSection && viewportWidth < 768) {
          tableSection.style.paddingRight = '0';
          lastPaddingState = '0';
        }
        if (tableBlock && viewportWidth < 768) {
          tableBlock.style.marginRight = '0';
          lastMarginState = '0';
        }
        wasAtEnd = false;
        wasAtStart = false;
        updateWrapperBorderRadius();
        return;
      }

      // --- COMPUTE (no DOM access) ---
      var thumbWidth = Math.max(clientWidth / scrollWidth * trackWidth, 50);
      var maxThumbLeft = trackWidth - thumbWidth;
      var thumbLeft = scrollLeft / scrollableWidth * maxThumbLeft;
      var threshold = 2;
      var endThresholdEnter = threshold + 12;
      var endThresholdExit = threshold + 6;
      var distanceFromEnd = scrollWidth - (scrollLeft + clientWidth);
      var isAtEnd;
      if (wasAtEnd) {
        isAtEnd = distanceFromEnd <= endThresholdExit;
      } else {
        isAtEnd = distanceFromEnd <= endThresholdEnter;
      }
      if (wasAtEnd !== isAtEnd) {
        wasAtEnd = isAtEnd;
      }

      // --- BATCH ALL WRITES ---
      scrollbar.style.display = 'block';
      scrollbarThumb.style.width = "".concat(thumbWidth, "px");
      scrollbarThumb.style.left = "".concat(thumbLeft, "px");
      if (viewportWidth < 768) {
        // Update padding-right on table section with progressive padding
        if (tableSection) {
          // Calculate progressive padding that increases as we approach the end
          var maxPadding = 20; // Maximum padding in pixels
          var paddingStartDistance = 30; // Start adding padding when 30px from end
          var endPadding = 0;
          if (distanceFromEnd < paddingStartDistance) {
            // Progressive padding: more padding as we get closer to the end
            var paddingRatio = 1 - distanceFromEnd / paddingStartDistance;
            endPadding = Math.max(0, Math.min(maxPadding, maxPadding * paddingRatio));
          }
          var newPaddingState = "".concat(endPadding, "px");
          if (lastPaddingState !== newPaddingState) {
            tableSection.style.paddingRight = newPaddingState;
            lastPaddingState = newPaddingState;
          }
        }

        // Update margin-right on content-card table block with progressive margin
        if (tableBlock) {
          // Calculate progressive margin that decreases as we approach the end
          // Margin goes from -20px (when far from end) to 0px (when at end)
          var maxMargin = 20; // Maximum margin in pixels (negative value)
          var marginStartDistance = 30; // Start changing margin when 30px from end
          var endMargin = -maxMargin; // Start with -20px

          if (distanceFromEnd < marginStartDistance) {
            // Progressive margin: less negative margin as we get closer to the end
            var marginRatio = 1 - distanceFromEnd / marginStartDistance;
            endMargin = -maxMargin + maxMargin * marginRatio; // Goes from -20px to 0px
          }
          var newMarginState = "".concat(endMargin, "px");
          if (lastMarginState !== newMarginState) {
            tableBlock.style.marginRight = newMarginState;
            lastMarginState = newMarginState;
          }
        }
      } else {
        // Desktop: Clean up mobile styles
        if (tableSection && lastPaddingState !== null) {
          tableSection.style.paddingRight = '';
          lastPaddingState = null;
        }
        if (tableBlock && lastMarginState !== null) {
          tableBlock.style.marginRight = '';
          lastMarginState = null;
        }
      }

      // Update wrapper border radius based on scroll position (mobile only)
      updateWrapperBorderRadius();
    };

    // Scroll table to position
    var scrollTo = scrollLeft => {
      tableContainer.scrollLeft = scrollLeft;
      updateScrollbar();
    };

    // Handle thumb drag start
    var handleThumbMouseDown = e => {
      isDragging = true;
      startX = e.clientX || e.touches[0].clientX;
      startScrollLeft = tableContainer.scrollLeft;
      e.preventDefault();
      e.stopPropagation();
    };

    // Handle thumb drag
    var handleThumbMouseMove = e => {
      if (!isDragging) return;
      var currentX = e.clientX || e.touches[0].clientX;
      var deltaX = currentX - startX;
      var trackWidth = scrollbarTrack.offsetWidth;
      var thumbWidth = scrollbarThumb.offsetWidth;
      var maxThumbLeft = trackWidth - thumbWidth;

      // Calculate scroll position
      var scrollWidth = tableContainer.scrollWidth,
        clientWidth = tableContainer.clientWidth;
      var scrollableWidth = scrollWidth - clientWidth;
      var thumbDeltaRatio = deltaX / maxThumbLeft;
      var scrollDelta = thumbDeltaRatio * scrollableWidth;
      scrollTo(startScrollLeft + scrollDelta);
    };

    // Handle thumb drag end
    var handleThumbMouseUp = () => {
      isDragging = false;
    };

    // Handle track click
    var handleTrackClick = e => {
      if (e.target === scrollbarThumb) return;
      var trackRect = scrollbarTrack.getBoundingClientRect();
      var clickX = e.clientX - trackRect.left;
      var trackWidth = scrollbarTrack.offsetWidth;
      var thumbWidth = scrollbarThumb.offsetWidth;
      var maxThumbLeft = trackWidth - thumbWidth;

      // Calculate target thumb position (centered on click)
      var targetThumbLeft = clickX - thumbWidth / 2;
      targetThumbLeft = Math.max(0, Math.min(targetThumbLeft, maxThumbLeft));

      // Calculate scroll position
      var scrollWidth = tableContainer.scrollWidth,
        clientWidth = tableContainer.clientWidth;
      var scrollableWidth = scrollWidth - clientWidth;
      var scrollRatio = targetThumbLeft / maxThumbLeft;
      var targetScrollLeft = scrollRatio * scrollableWidth;
      scrollTo(targetScrollLeft);
    };

    // Event listeners for thumb dragging
    scrollbarThumb.addEventListener('mousedown', handleThumbMouseDown);
    scrollbarThumb.addEventListener('touchstart', handleThumbMouseDown, {
      passive: false
    });
    document.addEventListener('mousemove', throttle(handleThumbMouseMove, 16));
    document.addEventListener('touchmove', throttle(handleThumbMouseMove, 16), {
      passive: false
    });
    document.addEventListener('mouseup', handleThumbMouseUp);
    document.addEventListener('touchend', handleThumbMouseUp);

    // Track click
    scrollbarTrack.addEventListener('click', handleTrackClick);

    // const debounce = (func, delay) => {
    //   let timeout;
    //   return function(...args) {
    //     clearTimeout(timeout);
    //     timeout = setTimeout(() => func.apply(this, args), delay);
    //   };
    // };

    function throttle(fn, delay) {
      var lastTime = 0;
      return function () {
        var now = Date.now();
        if (now - lastTime >= delay) {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          fn.apply(this, args);
          lastTime = now;
        }
      };
    }

    // Update scrollbar when table scrolls
    tableContainer.addEventListener('scroll', throttle(updateScrollbar, 10));

    // Allow any code (e.g. financial-data.js) to request a refresh when content is injected
    var handleScrollbarRefresh = () => {
      requestAnimationFrame(updateScrollbar);
      setTimeout(updateScrollbar, 100);
    };
    tableContainer.addEventListener('table-scrollbar-refresh', handleScrollbarRefresh);

    // Update scrollbar on resize
    var resizeTimeout;
    var handleResize = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        updateScrollbar();
      }, 100);
    };
    window.addEventListener('resize', handleResize);

    // Re-run when table content changes (e.g. data migration / async load) so scrollbar shows once overflow exists
    var contentCheckTimeout;
    var pollTimeout;
    var scheduleContentCheck = () => {
      clearTimeout(contentCheckTimeout);
      contentCheckTimeout = setTimeout(updateScrollbar, 150);
    };
    var mutationObserver = new MutationObserver(scheduleContentCheck);
    mutationObserver.observe(tableContainer, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style']
    });

    // Poll for overflow so we show scrollbar when async content (SEC API, financial-data, etc.) injects after init
    var POLL_INTERVAL = 400;
    var POLL_DURATION = 6000;
    var pollCount = 0;
    var pollUntilOverflowOrDone = () => {
      updateScrollbar();
      pollCount += 1;
      if (pollCount * POLL_INTERVAL < POLL_DURATION) {
        pollTimeout = setTimeout(pollUntilOverflowOrDone, POLL_INTERVAL);
      }
    };
    pollTimeout = setTimeout(pollUntilOverflowOrDone, POLL_INTERVAL);

    // When container becomes visible (e.g. section in tab or below fold), re-check overflow
    var intersectionObserver;
    if (typeof IntersectionObserver !== 'undefined') {
      intersectionObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            contentCheckTimeout = setTimeout(updateScrollbar, 100);
          }
        });
      }, {
        root: null,
        rootMargin: '0px',
        threshold: 0
      });
      intersectionObserver.observe(tableContainer);
    }

    // Initial update (may run before layout/content is ready)
    updateScrollbar();
    requestAnimationFrame(updateScrollbar);
    requestAnimationFrame(() => requestAnimationFrame(updateScrollbar));
    setTimeout(updateScrollbar, 100);
    setTimeout(updateScrollbar, 500);

    // Store cleanup function
    tableContainer._tableScrollbarCleanup = () => {
      mutationObserver.disconnect();
      if (intersectionObserver) intersectionObserver.disconnect();
      clearTimeout(contentCheckTimeout);
      clearTimeout(pollTimeout);
      scrollbarThumb.removeEventListener('mousedown', handleThumbMouseDown);
      scrollbarThumb.removeEventListener('touchstart', handleThumbMouseDown);
      document.removeEventListener('mousemove', handleThumbMouseMove);
      document.removeEventListener('touchmove', handleThumbMouseMove);
      document.removeEventListener('mouseup', handleThumbMouseUp);
      document.removeEventListener('touchend', handleThumbMouseUp);
      scrollbarTrack.removeEventListener('click', handleTrackClick);
      tableContainer.removeEventListener('scroll', updateScrollbar);
      tableContainer.removeEventListener('table-scrollbar-refresh', handleScrollbarRefresh);
      window.removeEventListener('resize', handleResize);

      // Clean up all applied styles
      if (tableSection) {
        tableSection.style.paddingRight = '';
      }
      if (tableBlock) {
        tableBlock.style.marginRight = '';
      }
      if (wrapper) {
        wrapper.style.paddingRight = '';
      }
      delete tableContainer.dataset.initialized;
    };
  });
}

// Re-initialize for Shopify theme editor
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', event => {
    initTableScrollbar(event.target);
  });
  document.addEventListener('shopify:section:unload', event => {
    var tableContainers = event.target.querySelectorAll('[data-table-scroll]');
    tableContainers.forEach(container => {
      if (container._tableScrollbarCleanup) {
        container._tableScrollbarCleanup();
      }
    });
  });
}

/***/ },

/***/ "./js/components/ui-components.js"
/*!****************************************!*\
  !*** ./js/components/ui-components.js ***!
  \****************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   initUIComponents: () => (/* binding */ initUIComponents)
/* harmony export */ });
/* unused harmony export attachUIEvents */
// ------------------------------
// UI ACCESSIBLE JS MODULE
// ------------------------------
function attachUIEvents() {
  var root = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  // =========================
  // MODALS
  // =========================
  var modals = root.querySelectorAll('[data-modal]');
  modals.forEach(modal => {
    if (modal.dataset._modalAttached) return;
    modal.dataset._modalAttached = true;
    var modalOpener = null;

    // Backdrop
    var backdrop = modal._backdrop;
    if (!backdrop) {
      backdrop = document.createElement('div');
      backdrop.className = 'tw-fixed tw-inset-0 tw-bg-black tw-bg-opacity-50 tw-hidden tw-z-[999999]';
      document.body.appendChild(backdrop);
      modal._backdrop = backdrop;
    }
    var toggleButtons = document.querySelectorAll("[data-modal-toggle=\"".concat(modal.id, "\"]"));
    var hideButtons = modal.querySelectorAll('[data-modal-hide]');
    var openModal = () => {
      var _modal$querySelector;
      modal.classList.remove('tw-hidden');
      backdrop.classList.remove('tw-hidden');

      // Lock background scroll
      document.body.style.overflow = 'hidden';
      (_modal$querySelector = modal.querySelector('button, [tabindex]')) === null || _modal$querySelector === void 0 || _modal$querySelector.focus();
    };
    var closeModal = () => {
      var _modalOpener;
      modal.classList.add('tw-hidden');
      backdrop.classList.add('tw-hidden');

      // Unlock background scroll
      document.body.style.overflow = '';
      (_modalOpener = modalOpener) === null || _modalOpener === void 0 || _modalOpener.focus();
      modalOpener = null;
    };
    toggleButtons.forEach(btn => {
      btn.addEventListener('click', e => {
        modalOpener = e.currentTarget;
        openModal();
      });
      btn.addEventListener('keydown', e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          modalOpener = e.currentTarget;
          openModal();
        }
      });
    });
    hideButtons.forEach(btn => btn.addEventListener('click', closeModal));
    backdrop.addEventListener('click', closeModal);
    modal.addEventListener('keydown', e => {
      if (e.key === 'Escape') {
        closeModal();
        return;
      }

      // Get all focusable elements inside the modal
      var focusable = modal.querySelectorAll('a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])');
      if (!focusable.length) return;
      var firstEl = focusable[0];
      var lastEl = focusable[focusable.length - 1];
      if (e.key === 'Tab') {
        if (!e.shiftKey && document.activeElement === lastEl) {
          // Tab on last element -> close modal
          e.preventDefault();
          closeModal();
        } else if (e.shiftKey && document.activeElement === firstEl) {
          // Shift + Tab on first element -> close modal
          e.preventDefault();
          closeModal();
        }
      }
    });
  });

  // =========================
  // DRAWERS (LEFT ONLY)
  // =========================
  var drawers = root.querySelectorAll('[data-drawer]');
  drawers.forEach(drawer => {
    if (drawer.dataset._drawerAttached) return;
    drawer.dataset._drawerAttached = true;
    var toggleButtons = document.querySelectorAll("[data-drawer-toggle=\"".concat(drawer.id, "\"]"));
    var hideButtons = drawer.querySelectorAll('[data-drawer-hide]');

    // Backdrop
    var backdrop = drawer._backdrop;
    if (!backdrop) {
      backdrop = document.createElement('div');
      backdrop.className = 'tw-fixed tw-inset-0 tw-bg-black tw-bg-opacity-50 tw-hidden tw-z-[999]';
      document.body.appendChild(backdrop);
      drawer._backdrop = backdrop;
    }
    drawer.classList.add('tw-fixed', 'tw-top-0', 'tw-left-0', 'tw-h-full', 'tw-bg-white', 'tw-shadow-xl', 'tw-w-72', 'tw-transform', 'tw-translate-x-[-100%]', 'tw-transition-transform', 'tw-duration-300', 'tw-ease-in-out', 'tw-z-[1000]');
    var openDrawer = () => {
      drawer.classList.remove('tw-hidden');
      backdrop.classList.remove('tw-hidden');
      requestAnimationFrame(() => drawer.style.transform = 'translateX(0)');
      toggleButtons.forEach(btn => btn.setAttribute('aria-expanded', 'true'));
    };
    var closeDrawer = () => {
      drawer.style.transform = 'translateX(-100%)';
      backdrop.classList.add('tw-hidden');
      setTimeout(() => drawer.classList.add('tw-hidden'), 300);
      toggleButtons.forEach(btn => btn.setAttribute('aria-expanded', 'false'));
    };
    toggleButtons.forEach(btn => btn.addEventListener('click', openDrawer));
    hideButtons.forEach(btn => btn.addEventListener('click', closeDrawer));
    backdrop.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && !drawer.classList.contains('tw-hidden')) closeDrawer();
    });
  });

  // ------------------------------
  // POPOVER
  // ------------------------------
  // ------------------------------
  // POPOVER
  // ------------------------------
  var popovers = root.querySelectorAll('[data-popover]');

  // Function to close all popovers except the one specified
  var closeAllPopoversExcept = exceptPopover => {
    popovers.forEach(p => {
      if (p !== exceptPopover && !p.classList.contains('tw-hidden')) {
        p.classList.add('tw-hidden');
      }
    });
  };

  // Helper function to get all focusable elements within a container
  var getFocusableElements = container => {
    var focusableSelectors = ['button:not([disabled])', '[href]', 'input:not([disabled]):not([type="hidden"])', 'select:not([disabled])', 'textarea:not([disabled])', '[tabindex]:not([tabindex="-1"])'].join(', ');
    return Array.from(container.querySelectorAll(focusableSelectors)).filter(el => {
      // Filter out elements that are not visible
      return el.offsetWidth > 0 && el.offsetHeight > 0 && window.getComputedStyle(el).visibility !== 'hidden' && window.getComputedStyle(el).display !== 'none';
    });
  };
  popovers.forEach(popover => {
    if (popover.dataset._popoverAttached) return;
    popover.dataset._popoverAttached = true;
    var toggleButtons = document.querySelectorAll("[data-popover-toggle=\"".concat(popover.id, "\"]"));
    var hideButtons = popover.querySelectorAll('[data-popover-hide]');

    // Store the last focused element before opening (for returning focus)
    var lastFocusedElement = null;
    var focusTrapHandler = null;
    var tabExitHandler = null;
    var focusInExitHandler = null;
    var openPopover = () => {
      // Close all other popovers first
      closeAllPopoversExcept(popover);
      popover.classList.remove('tw-hidden');

      // Store the currently focused element (the toggle button)
      lastFocusedElement = document.activeElement;

      // Keep focus on trigger button - don't auto-focus first element inside popover

      // Add focus trap for popups that need it (search, login, etc.)
      // Check if this popup should have focus trapping
      var needsFocusTrap = popover.id === 'header-search-popup' || popover.id === 'header-login-popup' || popover.hasAttribute('data-search-parent') || popover.hasAttribute('data-focus-trap');
      if (needsFocusTrap) {
        // Create focus trap handler for Tab key
        focusTrapHandler = e => {
          if (e.key !== 'Tab' || popover.classList.contains('tw-hidden')) return;
          var focusableElements = getFocusableElements(popover);
          if (focusableElements.length === 0) return;
          var firstElement = focusableElements[0];
          var lastElement = focusableElements[focusableElements.length - 1];

          // If only one focusable element, keep focus on it
          if (focusableElements.length === 1) {
            e.preventDefault();
            firstElement.focus();
            return;
          }

          // If Shift+Tab on first element, move to last
          if (e.shiftKey && document.activeElement === firstElement) {
            e.preventDefault();
            lastElement.focus();
            return;
          }

          // If Tab on last element, close popover and move focus outside
          if (!e.shiftKey && document.activeElement === lastElement) {
            e.preventDefault();
            e.stopPropagation();

            // Find next focusable element after popover
            var allFocusable = Array.from(document.querySelectorAll('button:not([disabled]), [href], input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(el => {
              return el.offsetWidth > 0 && el.offsetHeight > 0 && window.getComputedStyle(el).visibility !== 'hidden' && window.getComputedStyle(el).display !== 'none';
            });
            var lastElementIndex = allFocusable.indexOf(lastElement);
            var nextElementToFocus = null;
            if (lastElementIndex >= 0) {
              var _loop = function _loop() {
                var candidateElement = allFocusable[i];
                var isToggleButton = Array.from(toggleButtons).some(btn => btn === candidateElement);
                if (!popover.contains(candidateElement) && !isToggleButton) {
                  nextElementToFocus = candidateElement;
                  return 1; // break
                }
              };
              for (var i = lastElementIndex + 1; i < allFocusable.length; i++) {
                if (_loop()) break;
              }
            }

            // Close popover (skip returning focus to trigger)
            closePopover(true);

            // Focus next element
            if (nextElementToFocus) {
              requestAnimationFrame(() => {
                nextElementToFocus.focus();
              });
            }
            return;
          }

          // If focus is outside the popover, trap it back inside
          if (!popover.contains(document.activeElement)) {
            e.preventDefault();
            firstElement.focus();
          }
        };

        // Create focusin handler to catch any focus that escapes
        var focusInHandler = e => {
          if (popover.classList.contains('tw-hidden')) return;

          // If focus moved to something outside the popover, bring it back
          if (!popover.contains(e.target)) {
            var focusableElements = getFocusableElements(popover);
            if (focusableElements.length > 0) {
              focusableElements[0].focus();
            }
          }
        };

        // Add focus trap event listeners
        popover.addEventListener('keydown', focusTrapHandler);
        document.addEventListener('focusin', focusInHandler);

        // Store the focusin handler for cleanup
        popover._focusInHandler = focusInHandler;
      } else {
        // For popovers without focus trap, allow Tab to exit naturally
        // Tab on last element should close popover and move focus to next element
        tabExitHandler = e => {
          if (e.key !== 'Tab' || e.shiftKey || popover.classList.contains('tw-hidden')) return;
          var focusableElements = getFocusableElements(popover);
          if (focusableElements.length === 0) return;
          var lastElement = focusableElements[focusableElements.length - 1];
          var isLastElementFocused = document.activeElement === lastElement;
          if (isLastElementFocused) {
            e.preventDefault();
            e.stopPropagation();

            // Find next focusable element after popover
            var allFocusable = Array.from(document.querySelectorAll('button:not([disabled]), [href], input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(el => {
              return el.offsetWidth > 0 && el.offsetHeight > 0 && window.getComputedStyle(el).visibility !== 'hidden' && window.getComputedStyle(el).display !== 'none';
            });
            var lastElementIndex = allFocusable.indexOf(lastElement);
            var nextElementToFocus = null;
            if (lastElementIndex >= 0) {
              var _loop2 = function _loop2() {
                var candidateElement = allFocusable[i];
                var isToggleButton = Array.from(toggleButtons).some(btn => btn === candidateElement);
                if (!popover.contains(candidateElement) && !isToggleButton) {
                  nextElementToFocus = candidateElement;
                  return 1; // break
                }
              };
              for (var i = lastElementIndex + 1; i < allFocusable.length; i++) {
                if (_loop2()) break;
              }
            }

            // Close popover
            closePopover();

            // Focus next element
            if (nextElementToFocus) {
              requestAnimationFrame(() => {
                nextElementToFocus.focus();
              });
            }
          }
        };

        // Handle Shift+Tab on first element - move focus back to toggle
        var handleShiftTab = e => {
          if (e.key !== 'Tab' || !e.shiftKey || popover.classList.contains('tw-hidden')) return;
          var focusableElements = getFocusableElements(popover);
          if (focusableElements.length === 0) return;
          var firstElement = focusableElements[0];
          var isFirstElementFocused = document.activeElement === firstElement;
          if (isFirstElementFocused && toggleButtons.length > 0) {
            e.preventDefault();
            e.stopPropagation();
            toggleButtons[0].focus();
          }
        };
        popover.addEventListener('keydown', tabExitHandler, true);
        popover.addEventListener('keydown', handleShiftTab, true);
        popover._tabExitHandler = tabExitHandler;
        popover._handleShiftTab = handleShiftTab;
      }
    };
    var closePopover = function closePopover() {
      var skipFocusReturn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      popover.classList.add('tw-hidden');

      // Remove focus trap handlers
      if (focusTrapHandler) {
        popover.removeEventListener('keydown', focusTrapHandler);
        focusTrapHandler = null;
      }
      if (popover._focusInHandler) {
        document.removeEventListener('focusin', popover._focusInHandler);
        popover._focusInHandler = null;
      }

      // Remove tab exit handlers
      if (tabExitHandler) {
        popover.removeEventListener('keydown', tabExitHandler, true);
        tabExitHandler = null;
      }
      if (popover._handleShiftTab) {
        popover.removeEventListener('keydown', popover._handleShiftTab, true);
        popover._handleShiftTab = null;
      }

      // Return focus to the toggle button that opened it (unless skipping)
      if (!skipFocusReturn && lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
        setTimeout(() => {
          lastFocusedElement.focus();
          lastFocusedElement = null;
        }, 0);
      } else if (skipFocusReturn) {
        // Clear the last focused element when skipping focus return
        lastFocusedElement = null;
      }
    };

    // Click handler for toggle buttons
    toggleButtons.forEach(btn => {
      btn.addEventListener('click', e => {
        e.stopPropagation();
        if (popover.classList.contains('tw-hidden')) {
          openPopover();
        } else {
          closePopover();
        }
      });

      // Keyboard handler for toggle buttons (Enter/Space and Tab)
      btn.addEventListener('keydown', e => {
        var isPopoverOpen = !popover.classList.contains('tw-hidden');
        var isToggleFocused = document.activeElement === btn;

        // Enter/Space: Toggle popover
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          e.stopPropagation();
          if (isPopoverOpen) {
            closePopover();
          } else {
            openPopover();
          }
          return;
        }

        // Tab: Move focus from toggle to first item in popover when open
        if (e.key === 'Tab' && !e.shiftKey && isPopoverOpen && isToggleFocused) {
          e.preventDefault();
          e.stopPropagation();
          var focusableElements = getFocusableElements(popover);
          if (focusableElements.length > 0) {
            focusableElements[0].focus();
          }
        }
      }, true); // Use capture phase
    });
    hideButtons.forEach(btn => btn.addEventListener('click', closePopover));

    // Close on outside click (but not if clicking on toggle button)
    document.addEventListener('click', e => {
      var isToggleButton = Array.from(toggleButtons).some(btn => btn.contains(e.target));
      if (!popover.contains(e.target) && !isToggleButton && !popover.classList.contains('tw-hidden')) {
        closePopover();
      }
    });

    // Close on ESC - enhanced to work from anywhere
    var handleEscape = e => {
      if (e.key === 'Escape' && !popover.classList.contains('tw-hidden')) {
        e.preventDefault();
        e.stopPropagation();
        closePopover();
      }
    };

    // Attach Escape handler to toggle buttons and popover
    toggleButtons.forEach(btn => {
      btn.addEventListener('keydown', handleEscape);
    });
    popover.addEventListener('keydown', handleEscape);
  });

  // =========================
  // ACCORDIONS
  // =========================
  var accordions = root.querySelectorAll('[data-accordion]');
  accordions.forEach(acc => {
    if (acc.dataset._accordionAttached) return;
    acc.dataset._accordionAttached = true;
    var buttons = acc.querySelectorAll('[data-accordion-target]');
    buttons.forEach(btn => {
      var panel = document.getElementById(btn.dataset.accordionTarget);
      if (!panel) return; // Safety check

      // Find the parent accordion item that contains both button and panel
      // This works for any accordion structure (faq-accordion-item, footer-menu, etc.)
      var accordionItem = btn.parentElement;
      // Traverse up until we find the parent that contains the panel, or reach the accordion container
      while (accordionItem && accordionItem !== acc) {
        if (accordionItem.contains(panel)) {
          break; // Found the parent that contains both button and panel
        }
        accordionItem = accordionItem.parentElement;
      }
      // Ensure we have a valid accordion item (not the accordion container itself)
      if (!accordionItem || accordionItem === acc) {
        accordionItem = null;
      }
      btn.addEventListener('click', () => {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        panel.hidden = expanded;

        // Toggle active class on accordion item for CSS styling
        // Works globally for any accordion type
        if (accordionItem) {
          if (!expanded) {
            accordionItem.classList.add('is-active');
          } else {
            accordionItem.classList.remove('is-active');
          }
        }
      });
    });

    // // Open first FAQ accordion item on page load
    // const isFaqAccordion = acc.closest('[data-accordion]');

    // if (isFaqAccordion) {
    // 	const firstItem = isFaqAccordion.querySelector('.faq-section__accordion-item:first-child');
    // 	if (firstItem) {
    // 		const firstButton = firstItem.querySelector('[data-accordion-target]');
    // 		const firstPanel = firstItem.querySelector('.faq-section__accordion-panel');
    // 		if (firstButton && firstPanel) {
    // 			firstButton.setAttribute('aria-expanded', 'true');
    // 			firstPanel.hidden = false;
    // 			firstItem.classList.add('is-active');
    // 		}
    // 	}
    // }
  });

  // =========================
  // TABS (HORIZONTAL & VERTICAL)
  // =========================
  var tabLists = root.querySelectorAll('[data-tab-list]');
  tabLists.forEach(list => {
    if (list.dataset._tabAttached) return;
    list.dataset._tabAttached = true;
    var isTabSlide = list.hasAttribute('data-tab-slide');
    var tabs = list.querySelectorAll('[data-tab]');
    var orientation = list.dataset.tabOrientation || 'horizontal';
    var parentSection = list.closest('[data-tabs-section]');
    var tabContents = [...parentSection.querySelectorAll('[data-tab-content]')];
    if (!parentSection || tabContents.length <= 0) return;
    tabs.forEach((tab, index) => {
      var panelId = tab.dataset.tabTarget;
      tab.addEventListener('click', () => {
        tabs.forEach(t => {
          t.setAttribute('aria-selected', 'false');
          if (t.classList.contains('active')) {
            t.classList.remove('active');
          }
          tabContents.forEach(panel => {
            panel.classList.add('tw-hidden');
          });
          // Generic: Remove any --active modifier class
          Array.from(t.classList).forEach(cls => {
            if (cls.includes('--active')) {
              t.classList.remove(cls);
            }
          });
        });
        // Set active tab
        tab.setAttribute('aria-selected', 'true');
        tab.classList.add('active');
        var swiperEl = tab.closest('carousel-swiper');
        if (swiperEl && isTabSlide) {
          if (swiperEl.swiper) {
            swiperEl.swiper.slideTo(index);
          }
        }
        var activePanel = tabContents.filter(panel => panel.id === panelId);
        activePanel.forEach(panel => {
          panel.classList.remove('tw-hidden');
        });
        // Generic: Add --active modifier class
        // Find base class name and add --active variant
        Array.from(tab.classList).forEach(cls => {
          if (cls.includes('__tab-button') && !cls.includes('--')) {
            tab.classList.add(cls + '--active');
          }
        });
      });
      tab.addEventListener('keydown', e => {
        var index = Array.from(tabs).indexOf(tab);
        if (orientation === 'horizontal') {
          if (e.key === 'ArrowRight') index++;else if (e.key === 'ArrowLeft') index--;
        } else {
          if (e.key === 'ArrowDown') index++;else if (e.key === 'ArrowUp') index--;
        }
        if (index < 0) index = tabs.length - 1;
        if (index >= tabs.length) index = 0;
        tabs[index].focus();
      });
    });
  });
  console.log('UI events attached');
}

// ------------------------------
// INIT FUNCTION
// ------------------------------
function initUIComponents() {
  var root = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  attachUIEvents(root);
}

/***/ },

/***/ "./js/components/uniform-height.js"
/*!*****************************************!*\
  !*** ./js/components/uniform-height.js ***!
  \*****************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
var uniformHeight = () => {
  var cardSelector = '.column-card, .multicolumn-card, .column-card-block, .content-tab';
  var apply = () => {
    document.querySelectorAll('[data-uniform-height]').forEach(container => {
      var isCarousel = container.classList.contains('swiper-wrapper');
      var isDesktop = window.innerWidth >= 768;
      var applyBody = container.getAttribute('data-uniform-body') !== 'false';

      // For grid: only apply at 768px+, for carousel: apply always
      if (!isCarousel && !isDesktop) {
        container.querySelectorAll(cardSelector).forEach(card => {
          var sub = card.querySelector('[class*="__subheading"]');
          var body = card.querySelector('[class*="__text-"], .rich-text');
          if (sub) sub.style.minHeight = '';
          if (body) body.style.minHeight = '';
        });
        return;
      }
      var cards = container.querySelectorAll(cardSelector);
      if (!cards.length) return;
      var subheadings = [];
      var bodies = [];
      cards.forEach(card => {
        var sub = card.querySelector('[class*="__subheading"]');
        var body = card.querySelector('[class*="__text-"], .rich-text');
        if (sub) {
          sub.style.minHeight = '';
          subheadings.push(sub);
        }
        if (applyBody && body) {
          body.style.minHeight = '';
          bodies.push(body);
        }
      });
      requestAnimationFrame(() => {
        if (subheadings.length) {
          var maxSubH = Math.max(...subheadings.map(el => el.offsetHeight));
          subheadings.forEach(el => el.style.minHeight = maxSubH + 'px');
        }
        if (applyBody && bodies.length) {
          var maxBodyH = Math.max(...bodies.map(el => el.offsetHeight));
          bodies.forEach(el => el.style.minHeight = maxBodyH + 'px');
        }
      });
    });
  };
  var resizeTimer;
  var debouncedApply = () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(apply, 150);
  };
  var init = () => {
    apply();
    window.addEventListener('resize', debouncedApply);

    // Listen for tab changes (event delegation)
    document.addEventListener('click', e => {
      var tab = e.target.closest('[data-tab], [role="tab"], .tab-button, .tabs__button');
      if (tab) setTimeout(apply, 10);
    });
  };
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('migrationComplete', apply);
  document.addEventListener('shopify:section:load', apply);
  document.addEventListener('tabChange', apply);
  if (document.readyState !== 'loading') init();
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (uniformHeight);

/***/ },

/***/ "./js/sections/global.js"
/*!*******************************!*\
  !*** ./js/sections/global.js ***!
  \*******************************/
(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/esm/slicedToArray.js");
/* harmony import */ var JsComponents_autoplay_text_wrapper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! JsComponents/autoplay-text-wrapper.js */ "./js/components/autoplay-text-wrapper.js");
/* harmony import */ var JsComponents_ui_components_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! JsComponents/ui-components.js */ "./js/components/ui-components.js");
/* harmony import */ var JsComponents_header_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! JsComponents/header.js */ "./js/components/header.js");
/* harmony import */ var JsComponents_myapp_header_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! JsComponents/myapp-header.js */ "./js/components/myapp-header.js");
/* harmony import */ var JsComponents_migrate_section_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! JsComponents/migrate-section.js */ "./js/components/migrate-section.js");
/* harmony import */ var JsComponents_scroll_tab_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! JsComponents/scroll-tab.js */ "./js/components/scroll-tab.js");
/* harmony import */ var JsComponents_qualifier_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! JsComponents/qualifier.js */ "./js/components/qualifier.js");
/* harmony import */ var JsComponents_table_scrollbar_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! JsComponents/table-scrollbar.js */ "./js/components/table-scrollbar.js");
/* harmony import */ var JsComponents_financial_table_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! JsComponents/financial-table.js */ "./js/components/financial-table.js");
/* harmony import */ var JsComponents_financial_data_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! JsComponents/financial-data.js */ "./js/components/financial-data.js");
/* harmony import */ var _skeleton_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../skeleton.js */ "./js/skeleton.js");
/* harmony import */ var JsComponents_uniform_height_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! JsComponents/uniform-height.js */ "./js/components/uniform-height.js");
/* harmony import */ var JsComponents_smooth_scroll_hash_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! JsComponents/smooth-scroll-hash.js */ "./js/components/smooth-scroll-hash.js");

//global imports — heavy vendor deps are lazy-loaded to keep vendors.js small













window.initSkeleton = _skeleton_js__WEBPACK_IMPORTED_MODULE_11__.initSkeleton;
document.addEventListener('DOMContentLoaded', () => {
  (0,JsComponents_migrate_section_js__WEBPACK_IMPORTED_MODULE_5__.appendSection)();
  (0,JsComponents_migrate_section_js__WEBPACK_IMPORTED_MODULE_5__["default"])();
  (0,JsComponents_autoplay_text_wrapper_js__WEBPACK_IMPORTED_MODULE_1__["default"])();
  (0,JsComponents_ui_components_js__WEBPACK_IMPORTED_MODULE_2__.initUIComponents)();
  (0,JsComponents_table_scrollbar_js__WEBPACK_IMPORTED_MODULE_8__["default"])();
  (0,JsComponents_financial_data_js__WEBPACK_IMPORTED_MODULE_10__.initFinancialData)();
  (0,JsComponents_header_js__WEBPACK_IMPORTED_MODULE_3__["default"])();
  (0,JsComponents_myapp_header_js__WEBPACK_IMPORTED_MODULE_4__["default"])();
  (0,JsComponents_scroll_tab_js__WEBPACK_IMPORTED_MODULE_6__["default"])();
  (0,JsComponents_qualifier_js__WEBPACK_IMPORTED_MODULE_7__["default"])();
  (0,JsComponents_financial_table_js__WEBPACK_IMPORTED_MODULE_9__["default"])();
  (0,JsComponents_uniform_height_js__WEBPACK_IMPORTED_MODULE_12__["default"])();
  (0,JsComponents_smooth_scroll_hash_js__WEBPACK_IMPORTED_MODULE_13__["default"])();

  // Lazy-load Swiper carousel — only when <carousel-swiper> elements exist
  if (document.querySelector('carousel-swiper')) {
    Promise.all(/*! import() */[__webpack_require__.e("vendors-node_modules_babel_runtime_helpers_esm_defineProperty_js-node_modules_swiper_modules_-436186"), __webpack_require__.e("js_components_carousel-swiper_js")]).then(() => (__webpack_require__(/*! JsComponents/carousel-swiper */ "./js/components/carousel-swiper.js"))).then(_ref => {
      var CarouselSwiper = _ref.default;
      customElements.define('carousel-swiper', CarouselSwiper);
    });
  }

  // Lazy-load video.js — only when <video-player> elements exist
  if (document.querySelector('video-player')) {
    Promise.all([Promise.all(/*! import() */[__webpack_require__.e("vendors-node_modules_video_js_dist_video_es_js"), __webpack_require__.e("_34aa")]).then(() => (__webpack_require__(/*! video.js */ "./node_modules/video.js/dist/video.es.js"))), __webpack_require__.e(/*! import() */ "js_components_video_js").then(() => (__webpack_require__(/*! JsComponents/video.js */ "./js/components/video.js")))]).then(_ref2 => {
      var _ref3 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__["default"])(_ref2, 2),
        videojs = _ref3[0].default,
        VideoPlayer = _ref3[1].default;
      window.videojs = videojs;
      customElements.define('video-player', VideoPlayer);
    });
  }

  // Lazy-load PDF viewer — only when <pdf-viewer> elements exist
  if (document.querySelector('pdf-viewer')) {
    Promise.all(/*! import() */[__webpack_require__.e("vendors-node_modules_react-dom_index_js"), __webpack_require__.e("vendors-node_modules_react-dom_client_js-node_modules_babel_runtime_helpers_esm_defineProperty_js"), __webpack_require__.e("vendors-node_modules_react_jsx-runtime_js"), __webpack_require__.e("vendors-node_modules_embedpdf_react-pdf-viewer_dist_index_js"), __webpack_require__.e("js_components_pdf-viewer_js")]).then(() => (__webpack_require__(/*! JsComponents/pdf-viewer.js */ "./js/components/pdf-viewer.js"))).then(_ref4 => {
      var PDFViewer = _ref4.default;
      customElements.define('pdf-viewer', PDFViewer);
    });
  }

  // Lazy-load form validation (pulls in axios + libphonenumber) — only when forms exist
  if (document.querySelector('[data-form-id]')) {
    Promise.all([Promise.all(/*! import() */[__webpack_require__.e("vendors-node_modules_axios_lib_axios_js"), __webpack_require__.e("vendors-node_modules_babel_runtime_helpers_esm_defineProperty_js-node_modules_libphonenumber--92c373"), __webpack_require__.e("js_components_form-validation_js")]).then(() => (__webpack_require__(/*! JsComponents/form-validation.js */ "./js/components/form-validation.js"))), Promise.all(/*! import() */[__webpack_require__.e("vendors-node_modules_axios_lib_axios_js"), __webpack_require__.e("vendors-node_modules_babel_runtime_helpers_esm_defineProperty_js-node_modules_libphonenumber--92c373"), __webpack_require__.e("js_components_stepped-form_js")]).then(() => (__webpack_require__(/*! JsComponents/stepped-form.js */ "./js/components/stepped-form.js"))), Promise.all(/*! import() */[__webpack_require__.e("vendors-node_modules_axios_lib_axios_js"), __webpack_require__.e("vendors-node_modules_babel_runtime_helpers_esm_defineProperty_js-node_modules_libphonenumber--92c373"), __webpack_require__.e("js_components_gated-form_js")]).then(() => (__webpack_require__(/*! JsComponents/gated-form.js */ "./js/components/gated-form.js"))), Promise.all(/*! import() */[__webpack_require__.e("vendors-node_modules_axios_lib_axios_js"), __webpack_require__.e("vendors-node_modules_babel_runtime_helpers_esm_defineProperty_js-node_modules_libphonenumber--92c373"), __webpack_require__.e("js_components_express-multistep-form_js")]).then(() => (__webpack_require__(/*! JsComponents/express-multistep-form.js */ "./js/components/express-multistep-form.js")))]).then(_ref5 => {
      var _ref6 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__["default"])(_ref5, 4),
        initSimpleForm = _ref6[0].default,
        initSteppedForm = _ref6[1].default,
        initGatedForm = _ref6[2].default,
        initExpressMultistepForm = _ref6[3].default;
      initSteppedForm();
      initSimpleForm();
      initGatedForm();
      initExpressMultistepForm();
    });
  }

  // Lazy-load stock info (pulls in axios) — only when stock cards exist
  if (document.querySelector('[data-quote-card]')) {
    Promise.all(/*! import() */[__webpack_require__.e("vendors-node_modules_axios_lib_axios_js"), __webpack_require__.e("js_components_stock-info_js")]).then(() => (__webpack_require__(/*! JsComponents/stock-info.js */ "./js/components/stock-info.js"))).then(_ref7 => {
      var updateAllStockfields = _ref7.updateAllStockfields;
      updateAllStockfields();
    });
  }

  // Lazy-load LocationFinder + Google Maps — only when mount points exist
  if (document.querySelector('[data-location-finder-react]')) {
    Promise.all([Promise.all(/*! import() */[__webpack_require__.e("vendors-node_modules_axios_lib_axios_js"), __webpack_require__.e("vendors-node_modules_react-dom_index_js"), __webpack_require__.e("vendors-node_modules_react_jsx-runtime_js"), __webpack_require__.e("vendors-node_modules_react-google-maps_api_dist_esm_js"), __webpack_require__.e("js_components_LocationFinder_jsx")]).then(() => (__webpack_require__(/*! JsComponents/LocationFinder.jsx */ "./js/components/LocationFinder.jsx"))), Promise.all(/*! import() */[__webpack_require__.e("vendors-node_modules_react-dom_index_js"), __webpack_require__.e("vendors-node_modules_react-dom_client_js-node_modules_babel_runtime_helpers_esm_defineProperty_js"), __webpack_require__.e("vendors-node_modules_json-6_dist_index_js"), __webpack_require__.e("js_components_react-wrapper_js")]).then(() => (__webpack_require__(/*! JsComponents/react-wrapper.js */ "./js/components/react-wrapper.js")))]).then(_ref8 => {
      var _ref9 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__["default"])(_ref8, 2),
        LocationFinder = _ref9[0].default,
        reactWrapper = _ref9[1].default;
      reactWrapper(LocationFinder, '[data-location-finder-react]', '[data-location-finder-props]');
    });
  }
});

// Re-init megamenu in Shopify theme editor when header or megamenu sections reload
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', event => {
    (0,JsComponents_header_js__WEBPACK_IMPORTED_MODULE_3__["default"])(event.target);
    // Lazy-load form validation for dynamically added sections in theme editor
    if (event.target.querySelector('[data-form-id]')) {
      Promise.all([Promise.all(/*! import() */[__webpack_require__.e("vendors-node_modules_axios_lib_axios_js"), __webpack_require__.e("vendors-node_modules_babel_runtime_helpers_esm_defineProperty_js-node_modules_libphonenumber--92c373"), __webpack_require__.e("js_components_form-validation_js")]).then(() => (__webpack_require__(/*! JsComponents/form-validation.js */ "./js/components/form-validation.js"))), Promise.all(/*! import() */[__webpack_require__.e("vendors-node_modules_axios_lib_axios_js"), __webpack_require__.e("vendors-node_modules_babel_runtime_helpers_esm_defineProperty_js-node_modules_libphonenumber--92c373"), __webpack_require__.e("js_components_stepped-form_js")]).then(() => (__webpack_require__(/*! JsComponents/stepped-form.js */ "./js/components/stepped-form.js"))), Promise.all(/*! import() */[__webpack_require__.e("vendors-node_modules_axios_lib_axios_js"), __webpack_require__.e("vendors-node_modules_babel_runtime_helpers_esm_defineProperty_js-node_modules_libphonenumber--92c373"), __webpack_require__.e("js_components_gated-form_js")]).then(() => (__webpack_require__(/*! JsComponents/gated-form.js */ "./js/components/gated-form.js"))), Promise.all(/*! import() */[__webpack_require__.e("vendors-node_modules_axios_lib_axios_js"), __webpack_require__.e("vendors-node_modules_babel_runtime_helpers_esm_defineProperty_js-node_modules_libphonenumber--92c373"), __webpack_require__.e("js_components_express-multistep-form_js")]).then(() => (__webpack_require__(/*! JsComponents/express-multistep-form.js */ "./js/components/express-multistep-form.js")))]).then(_ref0 => {
        var _ref1 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__["default"])(_ref0, 4),
          initSimpleForm = _ref1[0].default,
          initSteppedForm = _ref1[1].default,
          initGatedForm = _ref1[2].default,
          initExpressMultistepForm = _ref1[3].default;
        initSteppedForm();
        initSimpleForm();
        initGatedForm();
        initExpressMultistepForm();
      });
    }
    // Lazy-load carousel for dynamically added sections
    if (event.target.querySelector('carousel-swiper') && !customElements.get('carousel-swiper')) {
      Promise.all(/*! import() */[__webpack_require__.e("vendors-node_modules_babel_runtime_helpers_esm_defineProperty_js-node_modules_swiper_modules_-436186"), __webpack_require__.e("js_components_carousel-swiper_js")]).then(() => (__webpack_require__(/*! JsComponents/carousel-swiper */ "./js/components/carousel-swiper.js"))).then(_ref10 => {
        var CarouselSwiper = _ref10.default;
        customElements.define('carousel-swiper', CarouselSwiper);
      });
    }
  });
}

/***/ },

/***/ "./js/skeleton.js"
/*!************************!*\
  !*** ./js/skeleton.js ***!
  \************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   initSkeleton: () => (/* binding */ initSkeleton)
/* harmony export */ });
/**
 * Table skeleton for loading state.
 * Injects a table-like skeleton into the container; replace container content when data arrives.
 */

function initSkeleton(container) {
  var _opts$rows, _opts$cols;
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var rows = (_opts$rows = opts.rows) !== null && _opts$rows !== void 0 ? _opts$rows : 8;
  var cols = (_opts$cols = opts.cols) !== null && _opts$cols !== void 0 ? _opts$cols : 4;
  var wrap = document.createElement('div');
  wrap.className = 'b2i-fin-api-content financial-statements-skeleton';
  wrap.setAttribute('aria-hidden', 'true');
  var table = document.createElement('table');
  table.className = 'report';
  table.setAttribute('role', 'presentation');
  var tbody = document.createElement('tbody');
  for (var r = 0; r < rows; r++) {
    var tr = document.createElement('tr');
    for (var c = 0; c < cols; c++) {
      var cell = document.createElement(r < 2 && c === 0 ? 'th' : 'td');
      var bar = document.createElement('span');
      bar.className = 'tw-block tw-h-4 tw-bg-gray-200 tw-rounded tw-animate-pulse';
      bar.style.width = c === 0 ? '70%' : '60%';
      bar.style.maxWidth = c === 0 ? '280px' : '80px';
      if (c > 0) bar.style.marginLeft = 'auto';
      cell.appendChild(bar);
      tr.appendChild(cell);
    }
    tbody.appendChild(tr);
  }
  table.appendChild(tbody);
  wrap.appendChild(table);
  container.innerHTML = '';
  container.appendChild(wrap);
  return () => {
    if (container.contains(wrap)) wrap.remove();
  };
}

/***/ }

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	const __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		const cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		const module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		if (!(moduleId in __webpack_modules__)) {
/******/ 			delete __webpack_module_cache__[moduleId];
/******/ 			const e = new Error("Cannot find module '" + moduleId + "'");
/******/ 			e.code = 'MODULE_NOT_FOUND';
/******/ 			throw e;
/******/ 		}
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		const deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn) => {
/******/ 			if(chunkIds) {
/******/ 				deferred.push([chunkIds, fn]);
/******/ 				return;
/******/ 			}
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				let [chunkIds, fn] = deferred[i];
/******/ 				let fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if (Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					const r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = (module) => {
/******/ 		const getter = module && module.__esModule ?
/******/ 			() => (module['default']) :
/******/ 			() => (module);
/******/ 		__webpack_require__.d(getter, { a: getter });
/******/ 		return getter;
/******/ 	};
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	// define getter/value functions for harmony exports
/******/ 	__webpack_require__.d = (exports, definition) => {
/******/ 		for(var key in definition) {
/******/ 			if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 				Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 			}
/******/ 		}
/******/ 	};
/******/ 	
/******/ 	/* webpack/runtime/ensure chunk */
/******/ 	__webpack_require__.f = {};
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = (chunkId) => {
/******/ 		return Promise.all(Object.keys(__webpack_require__.f).reduce((promises, key) => {
/******/ 			__webpack_require__.f[key](chunkId, promises);
/******/ 			return promises;
/******/ 		}, []));
/******/ 	};
/******/ 	
/******/ 	/* webpack/runtime/get javascript chunk filename */
/******/ 	// This function allow to reference async chunks
/******/ 	__webpack_require__.u = (chunkId) => ("./" + chunkId + ".js?" + {"vendors-node_modules_babel_runtime_helpers_esm_defineProperty_js-node_modules_swiper_modules_-436186":"b9177d0902644aa3d499","js_components_carousel-swiper_js":"4efdf3544402df21b572","vendors-node_modules_video_js_dist_video_es_js":"9e9d3e6a1ed53952ec2b","_34aa":"8705c44733fa61ee789c","js_components_video_js":"4e67861f80cba795da4c","vendors-node_modules_react-dom_index_js":"417c27bf9b1addce8ab2","vendors-node_modules_react-dom_client_js-node_modules_babel_runtime_helpers_esm_defineProperty_js":"69ce0bbf7e8c04abf450","vendors-node_modules_react_jsx-runtime_js":"b32f3920e5ddec646e3d","vendors-node_modules_embedpdf_react-pdf-viewer_dist_index_js":"f3760beee04aea80fa4d","js_components_pdf-viewer_js":"42d40cffcdf4fafa546b","vendors-node_modules_axios_lib_axios_js":"d077af70943114d520e0","vendors-node_modules_babel_runtime_helpers_esm_defineProperty_js-node_modules_libphonenumber--92c373":"d007371766c86183efcd","js_components_form-validation_js":"945091e7619e98445229","js_components_stepped-form_js":"c9c8f283749f7d2276cd","js_components_gated-form_js":"617fddefa0ce6640fd9b","js_components_express-multistep-form_js":"0c381899913d93342d5b","js_components_stock-info_js":"17b243fdce0d8401bdd9","vendors-node_modules_react-google-maps_api_dist_esm_js":"fbe34284c919fa5ae7fa","js_components_LocationFinder_jsx":"b514c269af3157010797","vendors-node_modules_json-6_dist_index_js":"b2f9f2fd73782110ac26","js_components_react-wrapper_js":"5ed45f7a45b860f25b03","vendors-node_modules_embedpdf_snippet_dist_browser-BKLM0ThC-BCLQGPD6_js":"9f61fcec049ce7e43ffb","vendors-node_modules_embedpdf_snippet_dist_worker-engine-BCCrxWYm_js":"a2a90cb15c8de7e01c18","vendors-node_modules_embedpdf_snippet_dist_direct-engine-DVLMOJWp_js":"9810fc23954206df41db"}[chunkId] + "");
/******/ 	
/******/ 	/* webpack/runtime/get mini-css chunk filename */
/******/ 	// This function allow to reference async chunks
/******/ 	__webpack_require__.miniCssF = (chunkId) => (undefined);
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	__webpack_require__.g = (function() {
/******/ 		if (typeof globalThis === 'object') return globalThis;
/******/ 		try {
/******/ 			return this || new Function('return this')();
/******/ 		} catch (e) {
/******/ 			if (typeof window === 'object') return window;
/******/ 		}
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop));
/******/ 	
/******/ 	/* webpack/runtime/load script */
/******/ 	(() => {
/******/ 		const inProgress = {};
/******/ 		const dataWebpackPrefix = "shoptrade-Shopify-Development:";
/******/ 		// loadScript function to load a script via script tag
/******/ 		__webpack_require__.l = (url, done, key, chunkId) => {
/******/ 			if(inProgress[url]) { inProgress[url].push(done); return; }
/******/ 			let script, needAttach;
/******/ 			if(key !== undefined) {
/******/ 				const scripts = document.getElementsByTagName("script");
/******/ 				for(var i = 0; i < scripts.length; i++) {
/******/ 					const s = scripts[i];
/******/ 					if(s.getAttribute("src") == url || s.getAttribute("data-webpack") == dataWebpackPrefix + key) { script = s; break; }
/******/ 				}
/******/ 			}
/******/ 			if(!script) {
/******/ 				needAttach = true;
/******/ 				script = document.createElement('script');
/******/ 		
/******/ 				script.charset = 'utf-8';
/******/ 				if (__webpack_require__.nc) {
/******/ 					script.setAttribute("nonce", __webpack_require__.nc);
/******/ 				}
/******/ 				script.setAttribute("data-webpack", dataWebpackPrefix + key);
/******/ 		
/******/ 				script.src = url;
/******/ 			}
/******/ 			inProgress[url] = [done];
/******/ 			const onScriptComplete = (prev, event) => {
/******/ 				// avoid mem leaks in IE.
/******/ 				script.onerror = script.onload = null;
/******/ 				clearTimeout(timeout);
/******/ 				const doneFns = inProgress[url];
/******/ 				delete inProgress[url];
/******/ 				script.parentNode?.removeChild(script);
/******/ 				doneFns?.forEach((fn) => (fn(event)));
/******/ 				if(prev) return prev(event);
/******/ 			}
/******/ 			const timeout = setTimeout(onScriptComplete.bind(null, undefined, { type: 'timeout', target: script }), 120000);
/******/ 			script.onerror = onScriptComplete.bind(null, script.onerror);
/******/ 			script.onload = onScriptComplete.bind(null, script.onload);
/******/ 			needAttach && document.head.appendChild(script);
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = (exports) => {
/******/ 		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	__webpack_require__.nmd = (module) => {
/******/ 		module.paths = [];
/******/ 		if (!module.children) module.children = [];
/******/ 		return module;
/******/ 	};
/******/ 	
/******/ 	/* webpack/runtime/set anonymous default export name */
/******/ 	// set .name for anonymous default exports per ES spec
/******/ 	// skipped when the property is non-configurable (pre-ES2015 engines),
/******/ 	// where Object.defineProperty would throw
/******/ 	__webpack_require__.dn = (x) => {
/******/ 		var descriptor = Object.getOwnPropertyDescriptor(x, "name");
/******/ 		if (!descriptor || (!descriptor.writable && descriptor.configurable)) Object.defineProperty(x, "name", { value: "default", configurable: true });
/******/ 	};
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	(() => {
/******/ 		let scriptUrl;
/******/ 		if (__webpack_require__.g.importScripts) scriptUrl = __webpack_require__.g.location + "";
/******/ 		const document = __webpack_require__.g.document;
/******/ 		if (!scriptUrl && document) {
/******/ 			if (document.currentScript?.tagName.toUpperCase() === 'SCRIPT')
/******/ 				scriptUrl = document.currentScript.src;
/******/ 			if (!scriptUrl) {
/******/ 				const scripts = document.getElementsByTagName("script");
/******/ 				if(scripts.length) {
/******/ 					let i = scripts.length - 1;
/******/ 					while (i > -1 && (!scriptUrl || !/^https?:/.test(scriptUrl))) scriptUrl = scripts[i--].src;
/******/ 				}
/******/ 			}
/******/ 		}
/******/ 		// When supporting browsers where an automatic publicPath is not supported you must specify an output.publicPath manually via configuration
/******/ 		// or pass an empty string ("") and set the __webpack_public_path__ variable from your code to use your own logic.
/******/ 		if (!scriptUrl) throw new Error("Automatic publicPath is not supported in this browser");
/******/ 		scriptUrl = scriptUrl.replace(/^blob:|[?#].*$/g, "").replace(/\/[^/]+$/, "/");
/******/ 		__webpack_require__.p = scriptUrl;
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		__webpack_require__.b = (typeof document !== 'undefined' && document.baseURI) || self.location.href;
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		const installedChunks = {
/******/ 			"global": 0
/******/ 		};
/******/ 		
/******/ 		__webpack_require__.f.j = (chunkId, promises) => {
/******/ 				// JSONP chunk loading for javascript
/******/ 				let installedChunkData = __webpack_require__.o(installedChunks, chunkId) ? installedChunks[chunkId] : undefined;
/******/ 				if(installedChunkData !== 0) { // 0 means "already installed".
/******/ 		
/******/ 					// a Promise means "currently loading".
/******/ 					if(installedChunkData) {
/******/ 						promises.push(installedChunkData[2]);
/******/ 					} else {
/******/ 						if(true) { // all chunks have JS
/******/ 							// setup Promise in chunk cache
/******/ 							const promise = new Promise((resolve, reject) => (installedChunkData = installedChunks[chunkId] = [resolve, reject]));
/******/ 							promises.push(installedChunkData[2] = promise);
/******/ 		
/******/ 							// create error before stack unwound to get useful stacktrace later
/******/ 							const error = new Error();
/******/ 							const loadingEnded = (event) => {
/******/ 								if(__webpack_require__.o(installedChunks, chunkId)) {
/******/ 									installedChunkData = installedChunks[chunkId];
/******/ 									if(installedChunkData !== 0) installedChunks[chunkId] = undefined;
/******/ 									if(installedChunkData) {
/******/ 										const errorType = event && (event.type === 'load' ? 'missing' : event.type);
/******/ 										const realSrc = event && event.target && event.target.src;
/******/ 										error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
/******/ 										error.name = 'ChunkLoadError';
/******/ 										error.type = errorType;
/******/ 										error.request = realSrc;
/******/ 										error.event = event;
/******/ 										installedChunkData[1](error);
/******/ 									}
/******/ 								}
/******/ 							};
/******/ 							__webpack_require__.l(__webpack_require__.p + __webpack_require__.u(chunkId), loadingEnded, "chunk-" + chunkId, chunkId);
/******/ 						}
/******/ 					}
/******/ 				}
/******/ 		};
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		const webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			let [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		const chunkLoadingGlobal = self["webpackChunkshoptrade_Shopify_Development"] = self["webpackChunkshoptrade_Shopify_Development"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	let __webpack_exports__ = __webpack_require__.O(undefined, ["vendors"], () => (__webpack_require__("./js/sections/global.js")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;